// Generated by tools/sprites/build.ts from the CC0 packs in corpus/. Do not edit; rebuild with
// `npm run sprites:build`. Sheets live in public/sprites/. Licences and sources per pack below.

import type { SpriteIndex } from "./sprites.js";

export const spriteIndex: SpriteIndex = {
 "packs": [
  { "id": "dungeon", "title": "Tiny Dungeon", "style": "pixel-16", "licence": "Kenney (kenney.nl), Creative Commons CC0", "source": "https://kenney.nl/assets/tiny-dungeon", "tags": "dungeon fantasy"
  },
  { "id": "town", "title": "Tiny Town", "style": "pixel-16", "licence": "Kenney (kenney.nl), Creative Commons CC0", "source": "https://kenney.nl/assets/tiny-town", "tags": "town village farm"
  },
  { "id": "platformer", "title": "Pixel Platformer", "style": "pixel-18", "licence": "Kenney (kenney.nl), Creative Commons CC0", "source": "https://kenney.nl/assets/pixel-platformer", "tags": "platformer side"
  },
  { "id": "emotes", "title": "Emotes Pack (pixel style 1)", "style": "pixel-16", "licence": "Kenney (kenney.nl), Creative Commons CC0", "source": "https://kenney.nl/assets/emotes-pack", "tags": "emote reaction speech bubble"
  },
  { "id": "space", "title": "Space Shooter Remastered", "style": "vector", "licence": "Kenney (kenney.nl), Creative Commons CC0", "source": "https://kenney.nl/assets/space-shooter-remastered", "tags": "space ship"
  },
  { "id": "topdown", "title": "Top-down Shooter (characters)", "style": "vector", "licence": "Kenney (kenney.nl), Creative Commons CC0", "source": "https://kenney.nl/assets/top-down-shooter", "tags": "person top-down"
  }
 ],
 "sprites": [
  { "name": "floor", "tags": "floor dungeon brown stone ground", "pack": "dungeon", "sheet": "dungeon.png", "x": 0, "y": 0, "w": 16, "h": 16
  },
  { "name": "floor-2", "tags": "floor dungeon brown ground", "pack": "dungeon", "sheet": "dungeon.png", "x": 16, "y": 0, "w": 16, "h": 16
  },
  { "name": "floor-edge-bottom-left", "tags": "floor edge wall corner", "pack": "dungeon", "sheet": "dungeon.png", "x": 32, "y": 0, "w": 16, "h": 16
  },
  { "name": "floor-edge-bottom-right", "tags": "floor edge wall corner", "pack": "dungeon", "sheet": "dungeon.png", "x": 48, "y": 0, "w": 16, "h": 16
  },
  { "name": "wall-top-left", "tags": "wall top stone edge", "pack": "dungeon", "sheet": "dungeon.png", "x": 64, "y": 0, "w": 16, "h": 16
  },
  { "name": "wall-top-right", "tags": "wall top stone edge", "pack": "dungeon", "sheet": "dungeon.png", "x": 80, "y": 0, "w": 16, "h": 16
  },
  { "name": "wall-pillar", "tags": "wall pillar column stone", "pack": "dungeon", "sheet": "dungeon.png", "x": 96, "y": 0, "w": 16, "h": 16
  },
  { "name": "wall-carving-skull", "tags": "wall carving skull ornament decoration", "pack": "dungeon", "sheet": "dungeon.png", "x": 112, "y": 0, "w": 16, "h": 16
  },
  { "name": "wall-carving-skull-glow", "tags": "wall carving skull green glow magic", "pack": "dungeon", "sheet": "dungeon.png", "x": 128, "y": 0, "w": 16, "h": 16
  },
  { "name": "dark-wall-left", "tags": "dark void wall edge", "pack": "dungeon", "sheet": "dungeon.png", "x": 144, "y": 0, "w": 16, "h": 16
  },
  { "name": "dark-wall-top", "tags": "dark void wall window", "pack": "dungeon", "sheet": "dungeon.png", "x": 160, "y": 0, "w": 16, "h": 16
  },
  { "name": "dark-wall-right", "tags": "dark void wall edge", "pack": "dungeon", "sheet": "dungeon.png", "x": 176, "y": 0, "w": 16, "h": 16
  },
  { "name": "floor-rubble", "tags": "floor debris stones rubble", "pack": "dungeon", "sheet": "dungeon.png", "x": 0, "y": 16, "w": 16, "h": 16
  },
  { "name": "floor-edge-left", "tags": "floor edge wall", "pack": "dungeon", "sheet": "dungeon.png", "x": 16, "y": 16, "w": 16, "h": 16
  },
  { "name": "wall-inner", "tags": "wall stone bricks inner", "pack": "dungeon", "sheet": "dungeon.png", "x": 32, "y": 16, "w": 16, "h": 16
  },
  { "name": "floor-edge-right", "tags": "floor edge wall", "pack": "dungeon", "sheet": "dungeon.png", "x": 48, "y": 16, "w": 16, "h": 16
  },
  { "name": "wall-corner-bottom-left", "tags": "wall corner stone", "pack": "dungeon", "sheet": "dungeon.png", "x": 64, "y": 16, "w": 16, "h": 16
  },
  { "name": "wall-corner-bottom-right", "tags": "wall corner stone", "pack": "dungeon", "sheet": "dungeon.png", "x": 80, "y": 16, "w": 16, "h": 16
  },
  { "name": "wall-end", "tags": "wall end cap stone", "pack": "dungeon", "sheet": "dungeon.png", "x": 96, "y": 16, "w": 16, "h": 16
  },
  { "name": "wall-carving-face", "tags": "wall carving gargoyle face decoration", "pack": "dungeon", "sheet": "dungeon.png", "x": 112, "y": 16, "w": 16, "h": 16
  },
  { "name": "wall-carving-face-glow", "tags": "wall carving gargoyle green glow magic", "pack": "dungeon", "sheet": "dungeon.png", "x": 128, "y": 16, "w": 16, "h": 16
  },
  { "name": "doorway-left", "tags": "doorway arch dark door frame", "pack": "dungeon", "sheet": "dungeon.png", "x": 144, "y": 16, "w": 16, "h": 16
  },
  { "name": "doorway-middle", "tags": "doorway arch dark open passage", "pack": "dungeon", "sheet": "dungeon.png", "x": 160, "y": 16, "w": 16, "h": 16
  },
  { "name": "doorway-right", "tags": "doorway arch dark door frame", "pack": "dungeon", "sheet": "dungeon.png", "x": 176, "y": 16, "w": 16, "h": 16
  },
  { "name": "floor-rubble-2", "tags": "floor debris stones rubble", "pack": "dungeon", "sheet": "dungeon.png", "x": 0, "y": 32, "w": 16, "h": 16
  },
  { "name": "floor-edge-top-left", "tags": "floor edge wall corner", "pack": "dungeon", "sheet": "dungeon.png", "x": 16, "y": 32, "w": 16, "h": 16
  },
  { "name": "floor-edge-top", "tags": "floor edge wall", "pack": "dungeon", "sheet": "dungeon.png", "x": 32, "y": 32, "w": 16, "h": 16
  },
  { "name": "floor-edge-top-right", "tags": "floor edge wall corner", "pack": "dungeon", "sheet": "dungeon.png", "x": 48, "y": 32, "w": 16, "h": 16
  },
  { "name": "wall-window-barred", "tags": "wall window bars prison", "pack": "dungeon", "sheet": "dungeon.png", "x": 64, "y": 32, "w": 16, "h": 16
  },
  { "name": "wall-banner-shield", "tags": "wall banner shield red heraldry decoration", "pack": "dungeon", "sheet": "dungeon.png", "x": 80, "y": 32, "w": 16, "h": 16
  },
  { "name": "sand-floor-corner", "tags": "sand floor orange edge corner", "pack": "dungeon", "sheet": "dungeon.png", "x": 96, "y": 32, "w": 16, "h": 16
  },
  { "name": "alcove", "tags": "alcove niche shelf stone", "pack": "dungeon", "sheet": "dungeon.png", "x": 112, "y": 32, "w": 16, "h": 16
  },
  { "name": "alcove-crystal", "tags": "alcove niche green crystal gem glow", "pack": "dungeon", "sheet": "dungeon.png", "x": 128, "y": 32, "w": 16, "h": 16
  },
  { "name": "door-frame-left", "tags": "door frame wood dark", "pack": "dungeon", "sheet": "dungeon.png", "x": 144, "y": 32, "w": 16, "h": 16
  },
  { "name": "door-frame-right", "tags": "door frame wood dark", "pack": "dungeon", "sheet": "dungeon.png", "x": 160, "y": 32, "w": 16, "h": 16
  },
  { "name": "door-frame-open", "tags": "door frame open dark passage", "pack": "dungeon", "sheet": "dungeon.png", "x": 176, "y": 32, "w": 16, "h": 16
  },
  { "name": "wall-left", "tags": "wall stone bricks end", "pack": "dungeon", "sheet": "dungeon.png", "x": 0, "y": 48, "w": 16, "h": 16
  },
  { "name": "wall", "tags": "wall stone bricks", "pack": "dungeon", "sheet": "dungeon.png", "x": 16, "y": 48, "w": 16, "h": 16
  },
  { "name": "wall-2", "tags": "wall stone bricks", "pack": "dungeon", "sheet": "dungeon.png", "x": 32, "y": 48, "w": 16, "h": 16
  },
  { "name": "wall-right", "tags": "wall stone bricks end", "pack": "dungeon", "sheet": "dungeon.png", "x": 48, "y": 48, "w": 16, "h": 16
  },
  { "name": "wall-plain", "tags": "wall stone bricks plain", "pack": "dungeon", "sheet": "dungeon.png", "x": 64, "y": 48, "w": 16, "h": 16
  },
  { "name": "wall-grate", "tags": "wall grate drain iron vent", "pack": "dungeon", "sheet": "dungeon.png", "x": 80, "y": 48, "w": 16, "h": 16
  },
  { "name": "sand-floor-tiles", "tags": "sand floor stone tiles orange", "pack": "dungeon", "sheet": "dungeon.png", "x": 96, "y": 48, "w": 16, "h": 16
  },
  { "name": "niche", "tags": "niche shelf stone empty", "pack": "dungeon", "sheet": "dungeon.png", "x": 112, "y": 48, "w": 16, "h": 16
  },
  { "name": "niche-crystal", "tags": "niche green crystal gem glow magic", "pack": "dungeon", "sheet": "dungeon.png", "x": 128, "y": 48, "w": 16, "h": 16
  },
  { "name": "door", "tags": "door wood closed", "pack": "dungeon", "sheet": "dungeon.png", "x": 144, "y": 48, "w": 16, "h": 16
  },
  { "name": "double-door-left", "tags": "door double wood closed", "pack": "dungeon", "sheet": "dungeon.png", "x": 160, "y": 48, "w": 16, "h": 16
  },
  { "name": "double-door-right", "tags": "door double wood closed", "pack": "dungeon", "sheet": "dungeon.png", "x": 176, "y": 48, "w": 16, "h": 16
  },
  { "name": "sand-floor", "tags": "sand floor orange ground", "pack": "dungeon", "sheet": "dungeon.png", "x": 0, "y": 64, "w": 16, "h": 16
  },
  { "name": "sand-floor-speckled", "tags": "sand floor orange ground", "pack": "dungeon", "sheet": "dungeon.png", "x": 16, "y": 64, "w": 16, "h": 16
  },
  { "name": "sand-floor-2", "tags": "sand floor orange ground", "pack": "dungeon", "sheet": "dungeon.png", "x": 32, "y": 64, "w": 16, "h": 16
  },
  { "name": "sand-floor-speckled-2", "tags": "sand floor orange ground", "pack": "dungeon", "sheet": "dungeon.png", "x": 48, "y": 64, "w": 16, "h": 16
  },
  { "name": "sand-floor-3", "tags": "sand floor orange ground", "pack": "dungeon", "sheet": "dungeon.png", "x": 64, "y": 64, "w": 16, "h": 16
  },
  { "name": "sand-floor-4", "tags": "sand floor orange ground", "pack": "dungeon", "sheet": "dungeon.png", "x": 80, "y": 64, "w": 16, "h": 16
  },
  { "name": "stone-block", "tags": "stone block carved pedestal", "pack": "dungeon", "sheet": "dungeon.png", "x": 96, "y": 64, "w": 16, "h": 16
  },
  { "name": "stone-block-top", "tags": "stone block trapdoor hatch", "pack": "dungeon", "sheet": "dungeon.png", "x": 112, "y": 64, "w": 16, "h": 16
  },
  { "name": "hole", "tags": "hole pit well stairs down", "pack": "dungeon", "sheet": "dungeon.png", "x": 128, "y": 64, "w": 16, "h": 16
  },
  { "name": "wall-top-cap-left", "tags": "wall top stone bricks", "pack": "dungeon", "sheet": "dungeon.png", "x": 144, "y": 64, "w": 16, "h": 16
  },
  { "name": "wall-top-cap", "tags": "wall top stone bricks", "pack": "dungeon", "sheet": "dungeon.png", "x": 160, "y": 64, "w": 16, "h": 16
  },
  { "name": "wall-top-cap-right", "tags": "wall top stone bricks", "pack": "dungeon", "sheet": "dungeon.png", "x": 176, "y": 64, "w": 16, "h": 16
  },
  { "name": "cursor-frame", "tags": "ui cursor selection frame target", "pack": "dungeon", "sheet": "dungeon.png", "x": 0, "y": 80, "w": 16, "h": 16
  },
  { "name": "cursor-box", "tags": "ui cursor selection box", "pack": "dungeon", "sheet": "dungeon.png", "x": 16, "y": 80, "w": 16, "h": 16
  },
  { "name": "cursor-lines", "tags": "ui cursor marker diagonal", "pack": "dungeon", "sheet": "dungeon.png", "x": 32, "y": 80, "w": 16, "h": 16
  },
  { "name": "crate", "tags": "crate box wood storage", "pack": "dungeon", "sheet": "dungeon.png", "x": 48, "y": 80, "w": 16, "h": 16
  },
  { "name": "anvil", "tags": "anvil forge smith stone", "pack": "dungeon", "sheet": "dungeon.png", "x": 64, "y": 80, "w": 16, "h": 16
  },
  { "name": "tombstone", "tags": "tombstone grave stone", "pack": "dungeon", "sheet": "dungeon.png", "x": 80, "y": 80, "w": 16, "h": 16
  },
  { "name": "boulder", "tags": "boulder rock stone round", "pack": "dungeon", "sheet": "dungeon.png", "x": 96, "y": 80, "w": 16, "h": 16
  },
  { "name": "cage-bars", "tags": "cage bars prison wood", "pack": "dungeon", "sheet": "dungeon.png", "x": 112, "y": 80, "w": 16, "h": 16
  },
  { "name": "cage-bars-2", "tags": "cage bars prison wood", "pack": "dungeon", "sheet": "dungeon.png", "x": 128, "y": 80, "w": 16, "h": 16
  },
  { "name": "rail-corner-top-left", "tags": "rail track fence corner", "pack": "dungeon", "sheet": "dungeon.png", "x": 144, "y": 80, "w": 16, "h": 16
  },
  { "name": "rail-top", "tags": "rail track fence", "pack": "dungeon", "sheet": "dungeon.png", "x": 160, "y": 80, "w": 16, "h": 16
  },
  { "name": "rail-corner-top-right", "tags": "rail track fence corner", "pack": "dungeon", "sheet": "dungeon.png", "x": 176, "y": 80, "w": 16, "h": 16
  },
  { "name": "table", "tags": "table bed furniture wood", "pack": "dungeon", "sheet": "dungeon.png", "x": 0, "y": 96, "w": 16, "h": 16
  },
  { "name": "stool", "tags": "stool chair furniture wood", "pack": "dungeon", "sheet": "dungeon.png", "x": 16, "y": 96, "w": 16, "h": 16
  },
  { "name": "grindstone", "tags": "grindstone anvil stone tool", "pack": "dungeon", "sheet": "dungeon.png", "x": 32, "y": 96, "w": 16, "h": 16
  },
  { "name": "crate-side", "tags": "crate box wood planks", "pack": "dungeon", "sheet": "dungeon.png", "x": 48, "y": 96, "w": 16, "h": 16
  },
  { "name": "fence-left", "tags": "fence wood end", "pack": "dungeon", "sheet": "dungeon.png", "x": 64, "y": 96, "w": 16, "h": 16
  },
  { "name": "fence", "tags": "fence wood", "pack": "dungeon", "sheet": "dungeon.png", "x": 80, "y": 96, "w": 16, "h": 16
  },
  { "name": "fence-right", "tags": "fence wood end", "pack": "dungeon", "sheet": "dungeon.png", "x": 96, "y": 96, "w": 16, "h": 16
  },
  { "name": "rail-horizontal", "tags": "rail track ladder wood", "pack": "dungeon", "sheet": "dungeon.png", "x": 112, "y": 96, "w": 16, "h": 16
  },
  { "name": "rail-horizontal-2", "tags": "rail track ladder wood", "pack": "dungeon", "sheet": "dungeon.png", "x": 128, "y": 96, "w": 16, "h": 16
  },
  { "name": "rail-left", "tags": "rail track fence vertical", "pack": "dungeon", "sheet": "dungeon.png", "x": 144, "y": 96, "w": 16, "h": 16
  },
  { "name": "barrel", "tags": "barrel keg wood storage", "pack": "dungeon", "sheet": "dungeon.png", "x": 160, "y": 96, "w": 16, "h": 16
  },
  { "name": "rail-right", "tags": "rail track fence vertical", "pack": "dungeon", "sheet": "dungeon.png", "x": 176, "y": 96, "w": 16, "h": 16
  },
  { "name": "wizard", "tags": "wizard mage sorcerer purple hat beard character npc", "pack": "dungeon", "sheet": "dungeon.png", "x": 0, "y": 112, "w": 16, "h": 16
  },
  { "name": "villager", "tags": "villager peasant bald character npc", "pack": "dungeon", "sheet": "dungeon.png", "x": 16, "y": 112, "w": 16, "h": 16
  },
  { "name": "bearded-man", "tags": "man beard villager character npc", "pack": "dungeon", "sheet": "dungeon.png", "x": 32, "y": 112, "w": 16, "h": 16
  },
  { "name": "helmeted-man", "tags": "man helmet grey character npc", "pack": "dungeon", "sheet": "dungeon.png", "x": 48, "y": 112, "w": 16, "h": 16
  },
  { "name": "bald-man", "tags": "man bald villager character npc", "pack": "dungeon", "sheet": "dungeon.png", "x": 64, "y": 112, "w": 16, "h": 16
  },
  { "name": "chest", "tags": "chest treasure closed wood lock", "pack": "dungeon", "sheet": "dungeon.png", "x": 80, "y": 112, "w": 16, "h": 16
  },
  { "name": "chest-iron", "tags": "chest treasure closed iron", "pack": "dungeon", "sheet": "dungeon.png", "x": 96, "y": 112, "w": 16, "h": 16
  },
  { "name": "chest-open", "tags": "chest treasure open", "pack": "dungeon", "sheet": "dungeon.png", "x": 112, "y": 112, "w": 16, "h": 16
  },
  { "name": "mimic", "tags": "mimic chest monster teeth enemy", "pack": "dungeon", "sheet": "dungeon.png", "x": 128, "y": 112, "w": 16, "h": 16
  },
  { "name": "rail-corner-bottom-left", "tags": "rail track fence corner", "pack": "dungeon", "sheet": "dungeon.png", "x": 144, "y": 112, "w": 16, "h": 16
  },
  { "name": "rail-bottom", "tags": "rail track fence", "pack": "dungeon", "sheet": "dungeon.png", "x": 160, "y": 112, "w": 16, "h": 16
  },
  { "name": "rail-corner-bottom-right", "tags": "rail track fence corner", "pack": "dungeon", "sheet": "dungeon.png", "x": 176, "y": 112, "w": 16, "h": 16
  },
  { "name": "knight", "tags": "knight armour helmet warrior hero character", "pack": "dungeon", "sheet": "dungeon.png", "x": 0, "y": 128, "w": 16, "h": 16
  },
  { "name": "knight-visor", "tags": "knight armour helmet visor warrior hero character", "pack": "dungeon", "sheet": "dungeon.png", "x": 16, "y": 128, "w": 16, "h": 16
  },
  { "name": "warrior", "tags": "warrior man brown hair hero character", "pack": "dungeon", "sheet": "dungeon.png", "x": 32, "y": 128, "w": 16, "h": 16
  },
  { "name": "princess", "tags": "princess girl woman blonde purple dress character npc", "pack": "dungeon", "sheet": "dungeon.png", "x": 48, "y": 128, "w": 16, "h": 16
  },
  { "name": "elder", "tags": "elder old man grey hair wise character npc", "pack": "dungeon", "sheet": "dungeon.png", "x": 64, "y": 128, "w": 16, "h": 16
  },
  { "name": "ring", "tags": "ring jewellery item treasure", "pack": "dungeon", "sheet": "dungeon.png", "x": 80, "y": 128, "w": 16, "h": 16
  },
  { "name": "coin", "tags": "coin stone round item", "pack": "dungeon", "sheet": "dungeon.png", "x": 96, "y": 128, "w": 16, "h": 16
  },
  { "name": "dagger", "tags": "dagger knife small sword weapon", "pack": "dungeon", "sheet": "dungeon.png", "x": 112, "y": 128, "w": 16, "h": 16
  },
  { "name": "sword", "tags": "sword blade weapon", "pack": "dungeon", "sheet": "dungeon.png", "x": 128, "y": 128, "w": 16, "h": 16
  },
  { "name": "knife-curved", "tags": "knife curved dagger weapon", "pack": "dungeon", "sheet": "dungeon.png", "x": 144, "y": 128, "w": 16, "h": 16
  },
  { "name": "sword-long", "tags": "sword long blade weapon", "pack": "dungeon", "sheet": "dungeon.png", "x": 160, "y": 128, "w": 16, "h": 16
  },
  { "name": "sword-fire", "tags": "sword fire orange flame magic weapon", "pack": "dungeon", "sheet": "dungeon.png", "x": 176, "y": 128, "w": 16, "h": 16
  },
  { "name": "slime", "tags": "slime green blob monster enemy", "pack": "dungeon", "sheet": "dungeon.png", "x": 0, "y": 144, "w": 16, "h": 16
  },
  { "name": "ogre", "tags": "ogre orc brute monster enemy", "pack": "dungeon", "sheet": "dungeon.png", "x": 16, "y": 144, "w": 16, "h": 16
  },
  { "name": "imp", "tags": "imp demon devil red horns monster enemy", "pack": "dungeon", "sheet": "dungeon.png", "x": 32, "y": 144, "w": 16, "h": 16
  },
  { "name": "dwarf", "tags": "dwarf beard red hood character npc", "pack": "dungeon", "sheet": "dungeon.png", "x": 48, "y": 144, "w": 16, "h": 16
  },
  { "name": "ranger", "tags": "ranger archer green hood character hero", "pack": "dungeon", "sheet": "dungeon.png", "x": 64, "y": 144, "w": 16, "h": 16
  },
  { "name": "flask", "tags": "flask empty bottle potion item", "pack": "dungeon", "sheet": "dungeon.png", "x": 80, "y": 144, "w": 16, "h": 16
  },
  { "name": "potion-green", "tags": "potion green bottle item heal", "pack": "dungeon", "sheet": "dungeon.png", "x": 96, "y": 144, "w": 16, "h": 16
  },
  { "name": "potion-red", "tags": "potion red bottle item health", "pack": "dungeon", "sheet": "dungeon.png", "x": 112, "y": 144, "w": 16, "h": 16
  },
  { "name": "potion-blue", "tags": "potion blue bottle item mana", "pack": "dungeon", "sheet": "dungeon.png", "x": 128, "y": 144, "w": 16, "h": 16
  },
  { "name": "hammer", "tags": "hammer mace weapon tool", "pack": "dungeon", "sheet": "dungeon.png", "x": 144, "y": 144, "w": 16, "h": 16
  },
  { "name": "axe-double", "tags": "axe double battle weapon", "pack": "dungeon", "sheet": "dungeon.png", "x": 160, "y": 144, "w": 16, "h": 16
  },
  { "name": "axe", "tags": "axe weapon tool", "pack": "dungeon", "sheet": "dungeon.png", "x": 176, "y": 144, "w": 16, "h": 16
  },
  { "name": "bat", "tags": "bat monster enemy flying", "pack": "dungeon", "sheet": "dungeon.png", "x": 0, "y": 160, "w": 16, "h": 16
  },
  { "name": "ghost", "tags": "ghost spirit monster enemy", "pack": "dungeon", "sheet": "dungeon.png", "x": 16, "y": 160, "w": 16, "h": 16
  },
  { "name": "spider", "tags": "spider monster enemy", "pack": "dungeon", "sheet": "dungeon.png", "x": 32, "y": 160, "w": 16, "h": 16
  },
  { "name": "crab", "tags": "crab scorpion claws monster enemy", "pack": "dungeon", "sheet": "dungeon.png", "x": 48, "y": 160, "w": 16, "h": 16
  },
  { "name": "eye-monster", "tags": "eye monster grey blob enemy", "pack": "dungeon", "sheet": "dungeon.png", "x": 64, "y": 160, "w": 16, "h": 16
  },
  { "name": "wand", "tags": "wand stick staff magic", "pack": "dungeon", "sheet": "dungeon.png", "x": 80, "y": 160, "w": 16, "h": 16
  },
  { "name": "staff-green", "tags": "staff wand green gem magic", "pack": "dungeon", "sheet": "dungeon.png", "x": 96, "y": 160, "w": 16, "h": 16
  },
  { "name": "staff-red", "tags": "staff wand red gem magic", "pack": "dungeon", "sheet": "dungeon.png", "x": 112, "y": 160, "w": 16, "h": 16
  },
  { "name": "staff-blue", "tags": "staff wand blue gem magic", "pack": "dungeon", "sheet": "dungeon.png", "x": 128, "y": 160, "w": 16, "h": 16
  },
  { "name": "torch", "tags": "torch flame light stick", "pack": "dungeon", "sheet": "dungeon.png", "x": 144, "y": 160, "w": 16, "h": 16
  },
  { "name": "vial-blue", "tags": "vial blue bottle potion item", "pack": "dungeon", "sheet": "dungeon.png", "x": 160, "y": 160, "w": 16, "h": 16
  },
  { "name": "quill", "tags": "quill pen feather item", "pack": "dungeon", "sheet": "dungeon.png", "x": 176, "y": 160, "w": 16, "h": 16
  },
  { "name": "grass", "tags": "grass green ground field", "pack": "town", "sheet": "town.png", "x": 0, "y": 0, "w": 16, "h": 16
  },
  { "name": "grass-tufts", "tags": "grass green ground tufts", "pack": "town", "sheet": "town.png", "x": 16, "y": 0, "w": 16, "h": 16
  },
  { "name": "grass-flowers", "tags": "grass green ground flowers yellow", "pack": "town", "sheet": "town.png", "x": 32, "y": 0, "w": 16, "h": 16
  },
  { "name": "tree-autumn-tall", "tags": "tree autumn orange tall pine", "pack": "town", "sheet": "town.png", "x": 48, "y": 0, "w": 16, "h": 16
  },
  { "name": "tree-pine-tall", "tags": "tree pine green tall conifer", "pack": "town", "sheet": "town.png", "x": 64, "y": 0, "w": 16, "h": 16
  },
  { "name": "tree-round", "tags": "tree round green bush oak", "pack": "town", "sheet": "town.png", "x": 80, "y": 0, "w": 16, "h": 16
  },
  { "name": "bush-pine", "tags": "bush pine small green", "pack": "town", "sheet": "town.png", "x": 96, "y": 0, "w": 16, "h": 16
  },
  { "name": "tree-pine", "tags": "tree pine green conifer", "pack": "town", "sheet": "town.png", "x": 112, "y": 0, "w": 16, "h": 16
  },
  { "name": "tree-pine-2", "tags": "tree pine green conifer", "pack": "town", "sheet": "town.png", "x": 128, "y": 0, "w": 16, "h": 16
  },
  { "name": "forest-autumn-left", "tags": "forest autumn orange trees edge", "pack": "town", "sheet": "town.png", "x": 144, "y": 0, "w": 16, "h": 16
  },
  { "name": "forest-autumn-top", "tags": "forest autumn orange trees edge", "pack": "town", "sheet": "town.png", "x": 160, "y": 0, "w": 16, "h": 16
  },
  { "name": "forest-autumn-right", "tags": "forest autumn orange trees edge", "pack": "town", "sheet": "town.png", "x": 176, "y": 0, "w": 16, "h": 16
  },
  { "name": "path-top-left", "tags": "path dirt corner grass edge", "pack": "town", "sheet": "town.png", "x": 0, "y": 16, "w": 16, "h": 16
  },
  { "name": "path-top", "tags": "path dirt edge grass", "pack": "town", "sheet": "town.png", "x": 16, "y": 16, "w": 16, "h": 16
  },
  { "name": "path-top-right", "tags": "path dirt corner grass edge", "pack": "town", "sheet": "town.png", "x": 32, "y": 16, "w": 16, "h": 16
  },
  { "name": "tree-autumn-round", "tags": "tree autumn orange round", "pack": "town", "sheet": "town.png", "x": 48, "y": 16, "w": 16, "h": 16
  },
  { "name": "tree-round-2", "tags": "tree round green oak", "pack": "town", "sheet": "town.png", "x": 64, "y": 16, "w": 16, "h": 16
  },
  { "name": "sapling", "tags": "sapling plant sprout seedling green", "pack": "town", "sheet": "town.png", "x": 80, "y": 16, "w": 16, "h": 16
  },
  { "name": "forest-left", "tags": "forest pine green trees edge", "pack": "town", "sheet": "town.png", "x": 96, "y": 16, "w": 16, "h": 16
  },
  { "name": "forest", "tags": "forest pine green trees dense", "pack": "town", "sheet": "town.png", "x": 112, "y": 16, "w": 16, "h": 16
  },
  { "name": "forest-right", "tags": "forest pine green trees edge", "pack": "town", "sheet": "town.png", "x": 128, "y": 16, "w": 16, "h": 16
  },
  { "name": "forest-autumn", "tags": "forest autumn orange trees dense", "pack": "town", "sheet": "town.png", "x": 160, "y": 16, "w": 16, "h": 16
  },
  { "name": "forest-autumn-2", "tags": "forest autumn orange trees dense", "pack": "town", "sheet": "town.png", "x": 176, "y": 16, "w": 16, "h": 16
  },
  { "name": "path-left", "tags": "path dirt edge grass", "pack": "town", "sheet": "town.png", "x": 0, "y": 32, "w": 16, "h": 16
  },
  { "name": "path", "tags": "path dirt ground", "pack": "town", "sheet": "town.png", "x": 16, "y": 32, "w": 16, "h": 16
  },
  { "name": "path-right", "tags": "path dirt edge grass", "pack": "town", "sheet": "town.png", "x": 32, "y": 32, "w": 16, "h": 16
  },
  { "name": "tree-autumn-small", "tags": "tree autumn orange small", "pack": "town", "sheet": "town.png", "x": 48, "y": 32, "w": 16, "h": 16
  },
  { "name": "tree-small", "tags": "tree green small", "pack": "town", "sheet": "town.png", "x": 64, "y": 32, "w": 16, "h": 16
  },
  { "name": "mushrooms", "tags": "mushrooms red toadstool fungus", "pack": "town", "sheet": "town.png", "x": 80, "y": 32, "w": 16, "h": 16
  },
  { "name": "forest-bottom-left", "tags": "forest pine green trees edge", "pack": "town", "sheet": "town.png", "x": 96, "y": 32, "w": 16, "h": 16
  },
  { "name": "forest-bottom", "tags": "forest pine green trees edge", "pack": "town", "sheet": "town.png", "x": 112, "y": 32, "w": 16, "h": 16
  },
  { "name": "forest-bottom-right", "tags": "forest pine green trees edge", "pack": "town", "sheet": "town.png", "x": 128, "y": 32, "w": 16, "h": 16
  },
  { "name": "forest-autumn-bottom-left", "tags": "forest autumn orange trees edge", "pack": "town", "sheet": "town.png", "x": 144, "y": 32, "w": 16, "h": 16
  },
  { "name": "forest-autumn-bottom", "tags": "forest autumn orange trees edge", "pack": "town", "sheet": "town.png", "x": 160, "y": 32, "w": 16, "h": 16
  },
  { "name": "forest-autumn-bottom-right", "tags": "forest autumn orange trees edge", "pack": "town", "sheet": "town.png", "x": 176, "y": 32, "w": 16, "h": 16
  },
  { "name": "path-bottom-left", "tags": "path dirt corner grass edge", "pack": "town", "sheet": "town.png", "x": 0, "y": 48, "w": 16, "h": 16
  },
  { "name": "path-bottom", "tags": "path dirt edge grass", "pack": "town", "sheet": "town.png", "x": 16, "y": 48, "w": 16, "h": 16
  },
  { "name": "path-bottom-right", "tags": "path dirt corner grass edge", "pack": "town", "sheet": "town.png", "x": 32, "y": 48, "w": 16, "h": 16
  },
  { "name": "dirt", "tags": "dirt soil ground brown field", "pack": "town", "sheet": "town.png", "x": 48, "y": 48, "w": 16, "h": 16
  },
  { "name": "dirt-tufts", "tags": "dirt soil ground grass tufts", "pack": "town", "sheet": "town.png", "x": 64, "y": 48, "w": 16, "h": 16
  },
  { "name": "dirt-2", "tags": "dirt soil ground brown", "pack": "town", "sheet": "town.png", "x": 80, "y": 48, "w": 16, "h": 16
  },
  { "name": "dirt-pebbles", "tags": "dirt soil ground pebbles", "pack": "town", "sheet": "town.png", "x": 96, "y": 48, "w": 16, "h": 16
  },
  { "name": "cobbles", "tags": "cobbles stones path paving grass", "pack": "town", "sheet": "town.png", "x": 112, "y": 48, "w": 16, "h": 16
  },
  { "name": "fence-left", "tags": "fence wood end post", "pack": "town", "sheet": "town.png", "x": 128, "y": 48, "w": 16, "h": 16
  },
  { "name": "fence", "tags": "fence wood", "pack": "town", "sheet": "town.png", "x": 144, "y": 48, "w": 16, "h": 16
  },
  { "name": "fence-right", "tags": "fence wood end post", "pack": "town", "sheet": "town.png", "x": 160, "y": 48, "w": 16, "h": 16
  },
  { "name": "fence-post", "tags": "fence wood post vertical", "pack": "town", "sheet": "town.png", "x": 176, "y": 48, "w": 16, "h": 16
  },
  { "name": "roof-slate-left", "tags": "roof slate grey tiles edge", "pack": "town", "sheet": "town.png", "x": 0, "y": 64, "w": 16, "h": 16
  },
  { "name": "roof-slate", "tags": "roof slate grey tiles", "pack": "town", "sheet": "town.png", "x": 16, "y": 64, "w": 16, "h": 16
  },
  { "name": "roof-slate-right", "tags": "roof slate grey tiles edge", "pack": "town", "sheet": "town.png", "x": 32, "y": 64, "w": 16, "h": 16
  },
  { "name": "roof-slate-window", "tags": "roof slate grey window dormer", "pack": "town", "sheet": "town.png", "x": 48, "y": 64, "w": 16, "h": 16
  },
  { "name": "roof-red-left", "tags": "roof red tiles edge", "pack": "town", "sheet": "town.png", "x": 64, "y": 64, "w": 16, "h": 16
  },
  { "name": "roof-red", "tags": "roof red tiles", "pack": "town", "sheet": "town.png", "x": 80, "y": 64, "w": 16, "h": 16
  },
  { "name": "roof-red-right", "tags": "roof red tiles edge", "pack": "town", "sheet": "town.png", "x": 96, "y": 64, "w": 16, "h": 16
  },
  { "name": "roof-red-window", "tags": "roof red window dormer", "pack": "town", "sheet": "town.png", "x": 112, "y": 64, "w": 16, "h": 16
  },
  { "name": "fence-corner-top-left", "tags": "fence wood corner", "pack": "town", "sheet": "town.png", "x": 128, "y": 64, "w": 16, "h": 16
  },
  { "name": "lantern-sign", "tags": "sign hanging lantern shop", "pack": "town", "sheet": "town.png", "x": 144, "y": 64, "w": 16, "h": 16
  },
  { "name": "fence-vertical", "tags": "fence wood vertical", "pack": "town", "sheet": "town.png", "x": 160, "y": 64, "w": 16, "h": 16
  },
  { "name": "fence-vertical-2", "tags": "fence wood vertical", "pack": "town", "sheet": "town.png", "x": 176, "y": 64, "w": 16, "h": 16
  },
  { "name": "roof-slate-lower-left", "tags": "roof slate grey tiles eave", "pack": "town", "sheet": "town.png", "x": 0, "y": 80, "w": 16, "h": 16
  },
  { "name": "roof-slate-lower", "tags": "roof slate grey tiles eave", "pack": "town", "sheet": "town.png", "x": 16, "y": 80, "w": 16, "h": 16
  },
  { "name": "roof-slate-lower-right", "tags": "roof slate grey tiles eave", "pack": "town", "sheet": "town.png", "x": 32, "y": 80, "w": 16, "h": 16
  },
  { "name": "roof-slate-peak", "tags": "roof slate grey gable peak", "pack": "town", "sheet": "town.png", "x": 48, "y": 80, "w": 16, "h": 16
  },
  { "name": "roof-red-lower-left", "tags": "roof red tiles eave", "pack": "town", "sheet": "town.png", "x": 64, "y": 80, "w": 16, "h": 16
  },
  { "name": "roof-red-lower", "tags": "roof red tiles eave", "pack": "town", "sheet": "town.png", "x": 80, "y": 80, "w": 16, "h": 16
  },
  { "name": "roof-red-lower-right", "tags": "roof red tiles eave", "pack": "town", "sheet": "town.png", "x": 96, "y": 80, "w": 16, "h": 16
  },
  { "name": "roof-red-peak", "tags": "roof red gable peak", "pack": "town", "sheet": "town.png", "x": 112, "y": 80, "w": 16, "h": 16
  },
  { "name": "fence-corner-bottom-left", "tags": "fence wood corner", "pack": "town", "sheet": "town.png", "x": 128, "y": 80, "w": 16, "h": 16
  },
  { "name": "fence-bottom", "tags": "fence wood", "pack": "town", "sheet": "town.png", "x": 144, "y": 80, "w": 16, "h": 16
  },
  { "name": "fence-corner-bottom-right", "tags": "fence wood corner", "pack": "town", "sheet": "town.png", "x": 160, "y": 80, "w": 16, "h": 16
  },
  { "name": "fence-vertical-3", "tags": "fence wood vertical", "pack": "town", "sheet": "town.png", "x": 176, "y": 80, "w": 16, "h": 16
  },
  { "name": "wall-wood-left", "tags": "wall wood planks house edge", "pack": "town", "sheet": "town.png", "x": 0, "y": 96, "w": 16, "h": 16
  },
  { "name": "wall-wood", "tags": "wall wood planks house", "pack": "town", "sheet": "town.png", "x": 16, "y": 96, "w": 16, "h": 16
  },
  { "name": "wall-wood-doorway", "tags": "wall wood planks doorway dark open", "pack": "town", "sheet": "town.png", "x": 32, "y": 96, "w": 16, "h": 16
  },
  { "name": "wall-wood-right", "tags": "wall wood planks house edge", "pack": "town", "sheet": "town.png", "x": 48, "y": 96, "w": 16, "h": 16
  },
  { "name": "wall-stone-left", "tags": "wall stone grey house edge", "pack": "town", "sheet": "town.png", "x": 64, "y": 96, "w": 16, "h": 16
  },
  { "name": "wall-stone", "tags": "wall stone grey house", "pack": "town", "sheet": "town.png", "x": 80, "y": 96, "w": 16, "h": 16
  },
  { "name": "wall-stone-doorway", "tags": "wall stone grey doorway dark open", "pack": "town", "sheet": "town.png", "x": 96, "y": 96, "w": 16, "h": 16
  },
  { "name": "wall-stone-right", "tags": "wall stone grey house edge", "pack": "town", "sheet": "town.png", "x": 112, "y": 96, "w": 16, "h": 16
  },
  { "name": "fence-short-left", "tags": "fence wood short end", "pack": "town", "sheet": "town.png", "x": 128, "y": 96, "w": 16, "h": 16
  },
  { "name": "fence-horizontal", "tags": "fence wood horizontal rail", "pack": "town", "sheet": "town.png", "x": 144, "y": 96, "w": 16, "h": 16
  },
  { "name": "fence-short-right", "tags": "fence wood short end", "pack": "town", "sheet": "town.png", "x": 160, "y": 96, "w": 16, "h": 16
  },
  { "name": "signpost", "tags": "sign signpost wood board notice", "pack": "town", "sheet": "town.png", "x": 176, "y": 96, "w": 16, "h": 16
  },
  { "name": "wall-wood-window", "tags": "wall wood window house", "pack": "town", "sheet": "town.png", "x": 0, "y": 112, "w": 16, "h": 16
  },
  { "name": "wall-wood-door", "tags": "wall wood door house closed", "pack": "town", "sheet": "town.png", "x": 16, "y": 112, "w": 16, "h": 16
  },
  { "name": "wall-wood-door-2", "tags": "wall wood door house closed", "pack": "town", "sheet": "town.png", "x": 32, "y": 112, "w": 16, "h": 16
  },
  { "name": "wall-wood-door-3", "tags": "wall wood door house closed", "pack": "town", "sheet": "town.png", "x": 48, "y": 112, "w": 16, "h": 16
  },
  { "name": "wall-stone-window", "tags": "wall stone window house", "pack": "town", "sheet": "town.png", "x": 64, "y": 112, "w": 16, "h": 16
  },
  { "name": "wall-stone-door", "tags": "wall stone door house closed", "pack": "town", "sheet": "town.png", "x": 80, "y": 112, "w": 16, "h": 16
  },
  { "name": "wall-stone-door-2", "tags": "wall stone door house closed", "pack": "town", "sheet": "town.png", "x": 96, "y": 112, "w": 16, "h": 16
  },
  { "name": "wall-stone-door-3", "tags": "wall stone door house closed", "pack": "town", "sheet": "town.png", "x": 112, "y": 112, "w": 16, "h": 16
  },
  { "name": "shed-roof", "tags": "shed roof small hut tent", "pack": "town", "sheet": "town.png", "x": 128, "y": 112, "w": 16, "h": 16
  },
  { "name": "haystack", "tags": "haystack hay bale straw farm", "pack": "town", "sheet": "town.png", "x": 144, "y": 112, "w": 16, "h": 16
  },
  { "name": "beehive", "tags": "beehive bees honey farm yellow", "pack": "town", "sheet": "town.png", "x": 160, "y": 112, "w": 16, "h": 16
  },
  { "name": "target", "tags": "target archery bullseye", "pack": "town", "sheet": "town.png", "x": 176, "y": 112, "w": 16, "h": 16
  },
  { "name": "plaster-top-left", "tags": "wall plaster white tower edge", "pack": "town", "sheet": "town.png", "x": 0, "y": 128, "w": 16, "h": 16
  },
  { "name": "plaster-top", "tags": "wall plaster white tower edge", "pack": "town", "sheet": "town.png", "x": 16, "y": 128, "w": 16, "h": 16
  },
  { "name": "plaster-top-right", "tags": "wall plaster white tower edge", "pack": "town", "sheet": "town.png", "x": 32, "y": 128, "w": 16, "h": 16
  },
  { "name": "battlement-left", "tags": "wall castle battlement stone edge", "pack": "town", "sheet": "town.png", "x": 48, "y": 128, "w": 16, "h": 16
  },
  { "name": "battlement", "tags": "wall castle battlement stone", "pack": "town", "sheet": "town.png", "x": 64, "y": 128, "w": 16, "h": 16
  },
  { "name": "battlement-2", "tags": "wall castle battlement stone", "pack": "town", "sheet": "town.png", "x": 80, "y": 128, "w": 16, "h": 16
  },
  { "name": "battlement-right", "tags": "wall castle battlement stone edge", "pack": "town", "sheet": "town.png", "x": 96, "y": 128, "w": 16, "h": 16
  },
  { "name": "ladder", "tags": "ladder wood climb", "pack": "town", "sheet": "town.png", "x": 112, "y": 128, "w": 16, "h": 16
  },
  { "name": "well", "tags": "well water bucket stone", "pack": "town", "sheet": "town.png", "x": 128, "y": 128, "w": 16, "h": 16
  },
  { "name": "cauldron", "tags": "cauldron pot iron cooking", "pack": "town", "sheet": "town.png", "x": 144, "y": 128, "w": 16, "h": 16
  },
  { "name": "drawer", "tags": "drawer chest box wood furniture", "pack": "town", "sheet": "town.png", "x": 160, "y": 128, "w": 16, "h": 16
  },
  { "name": "bowl", "tags": "bowl pot clay", "pack": "town", "sheet": "town.png", "x": 176, "y": 128, "w": 16, "h": 16
  },
  { "name": "plaster-left", "tags": "wall plaster white tower edge", "pack": "town", "sheet": "town.png", "x": 0, "y": 144, "w": 16, "h": 16
  },
  { "name": "plaster", "tags": "wall plaster white tower", "pack": "town", "sheet": "town.png", "x": 16, "y": 144, "w": 16, "h": 16
  },
  { "name": "plaster-right", "tags": "wall plaster white tower edge", "pack": "town", "sheet": "town.png", "x": 32, "y": 144, "w": 16, "h": 16
  },
  { "name": "gate-portcullis", "tags": "gate castle arch portcullis bars", "pack": "town", "sheet": "town.png", "x": 48, "y": 144, "w": 16, "h": 16
  },
  { "name": "gate-closed", "tags": "gate castle arch closed", "pack": "town", "sheet": "town.png", "x": 64, "y": 144, "w": 16, "h": 16
  },
  { "name": "arch", "tags": "arch bridge stone open", "pack": "town", "sheet": "town.png", "x": 80, "y": 144, "w": 16, "h": 16
  },
  { "name": "arch-2", "tags": "arch bridge stone open", "pack": "town", "sheet": "town.png", "x": 96, "y": 144, "w": 16, "h": 16
  },
  { "name": "pickaxe", "tags": "pickaxe tool mining", "pack": "town", "sheet": "town.png", "x": 112, "y": 144, "w": 16, "h": 16
  },
  { "name": "pitchfork", "tags": "pitchfork fork rake tool farm", "pack": "town", "sheet": "town.png", "x": 128, "y": 144, "w": 16, "h": 16
  },
  { "name": "key", "tags": "key item unlock", "pack": "town", "sheet": "town.png", "x": 144, "y": 144, "w": 16, "h": 16
  },
  { "name": "bow", "tags": "bow weapon archery", "pack": "town", "sheet": "town.png", "x": 160, "y": 144, "w": 16, "h": 16
  },
  { "name": "arrow", "tags": "arrow weapon archery", "pack": "town", "sheet": "town.png", "x": 176, "y": 144, "w": 16, "h": 16
  },
  { "name": "plaster-bottom-left", "tags": "wall plaster white tower edge", "pack": "town", "sheet": "town.png", "x": 0, "y": 160, "w": 16, "h": 16
  },
  { "name": "plaster-bottom", "tags": "wall plaster white tower edge", "pack": "town", "sheet": "town.png", "x": 16, "y": 160, "w": 16, "h": 16
  },
  { "name": "plaster-bottom-right", "tags": "wall plaster white tower edge", "pack": "town", "sheet": "town.png", "x": 32, "y": 160, "w": 16, "h": 16
  },
  { "name": "wall-dark", "tags": "wall dark stone tower", "pack": "town", "sheet": "town.png", "x": 48, "y": 160, "w": 16, "h": 16
  },
  { "name": "wall-dark-2", "tags": "wall dark stone tower", "pack": "town", "sheet": "town.png", "x": 64, "y": 160, "w": 16, "h": 16
  },
  { "name": "wall-window-small", "tags": "wall plaster small window", "pack": "town", "sheet": "town.png", "x": 80, "y": 160, "w": 16, "h": 16
  },
  { "name": "bricks", "tags": "wall bricks stone grey", "pack": "town", "sheet": "town.png", "x": 96, "y": 160, "w": 16, "h": 16
  },
  { "name": "sickle", "tags": "sickle scythe tool farm harvest", "pack": "town", "sheet": "town.png", "x": 112, "y": 160, "w": 16, "h": 16
  },
  { "name": "hammer", "tags": "hammer tool red", "pack": "town", "sheet": "town.png", "x": 128, "y": 160, "w": 16, "h": 16
  },
  { "name": "hatchet", "tags": "hatchet axe tool wood", "pack": "town", "sheet": "town.png", "x": 144, "y": 160, "w": 16, "h": 16
  },
  { "name": "bucket", "tags": "bucket empty wood", "pack": "town", "sheet": "town.png", "x": 160, "y": 160, "w": 16, "h": 16
  },
  { "name": "bucket-water", "tags": "bucket water full wood", "pack": "town", "sheet": "town.png", "x": 176, "y": 160, "w": 16, "h": 16
  },
  { "name": "ground-grass-left", "tags": "ground grass dirt platform top edge", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 0, "y": 0, "w": 18, "h": 18
  },
  { "name": "ground-grass", "tags": "ground grass dirt platform top", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 18, "y": 0, "w": 18, "h": 18
  },
  { "name": "ground-grass-2", "tags": "ground grass dirt platform top", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 36, "y": 0, "w": 18, "h": 18
  },
  { "name": "ground-grass-right", "tags": "ground grass dirt platform top edge", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 54, "y": 0, "w": 18, "h": 18
  },
  { "name": "dirt", "tags": "dirt ground block brown", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 72, "y": 0, "w": 18, "h": 18
  },
  { "name": "dirt-roots", "tags": "dirt ground block brown roots", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 90, "y": 0, "w": 18, "h": 18
  },
  { "name": "dirt-block", "tags": "dirt block framed brown", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 108, "y": 0, "w": 18, "h": 18
  },
  { "name": "pebble", "tags": "pebble rock small brown", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 126, "y": 0, "w": 18, "h": 18
  },
  { "name": "pebble-small", "tags": "pebble rock tiny brown", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 144, "y": 0, "w": 18, "h": 18
  },
  { "name": "block-yellow", "tags": "block yellow plain", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 162, "y": 0, "w": 18, "h": 18
  },
  { "name": "block-exclamation", "tags": "block yellow exclamation question bonus", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 180, "y": 0, "w": 18, "h": 18
  },
  { "name": "block-coin", "tags": "block yellow coin bonus", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 198, "y": 0, "w": 18, "h": 18
  },
  { "name": "mushroom-cap-left", "tags": "mushroom cap red spots platform edge", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 216, "y": 0, "w": 18, "h": 18
  },
  { "name": "mushroom-cap", "tags": "mushroom cap red spots platform", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 234, "y": 0, "w": 18, "h": 18
  },
  { "name": "mushroom-cap-right", "tags": "mushroom cap red spots platform edge", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 252, "y": 0, "w": 18, "h": 18
  },
  { "name": "mushroom-cap-single", "tags": "mushroom cap red spots platform small", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 270, "y": 0, "w": 18, "h": 18
  },
  { "name": "hedge-corner", "tags": "hedge bush green corner", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 288, "y": 0, "w": 18, "h": 18
  },
  { "name": "hedge-left", "tags": "hedge bush green edge", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 306, "y": 0, "w": 18, "h": 18
  },
  { "name": "hedge", "tags": "hedge bush green", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 324, "y": 0, "w": 18, "h": 18
  },
  { "name": "hedge-right", "tags": "hedge bush green edge", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 342, "y": 0, "w": 18, "h": 18
  },
  { "name": "ground-grass-corner-left", "tags": "ground grass dirt corner edge", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 0, "y": 18, "w": 18, "h": 18
  },
  { "name": "ground-grass-inner", "tags": "ground grass dirt inner", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 18, "y": 18, "w": 18, "h": 18
  },
  { "name": "ground-grass-inner-2", "tags": "ground grass dirt inner", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 36, "y": 18, "w": 18, "h": 18
  },
  { "name": "ground-grass-corner-right", "tags": "ground grass dirt corner edge", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 54, "y": 18, "w": 18, "h": 18
  },
  { "name": "dirt-2", "tags": "dirt ground block brown", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 72, "y": 18, "w": 18, "h": 18
  },
  { "name": "dirt-3", "tags": "dirt ground block brown", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 90, "y": 18, "w": 18, "h": 18
  },
  { "name": "dirt-slope", "tags": "dirt ground slope diagonal brown", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 108, "y": 18, "w": 18, "h": 18
  },
  { "name": "key", "tags": "key gold item unlock", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 126, "y": 18, "w": 18, "h": 18
  },
  { "name": "block-lock", "tags": "block lock keyhole yellow door", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 144, "y": 18, "w": 18, "h": 18
  },
  { "name": "crate", "tags": "crate box wood", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 162, "y": 18, "w": 18, "h": 18
  },
  { "name": "block-lock-2", "tags": "block lock yellow", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 180, "y": 18, "w": 18, "h": 18
  },
  { "name": "block-lock-3", "tags": "block lock yellow", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 198, "y": 18, "w": 18, "h": 18
  },
  { "name": "mushroom-stem-top", "tags": "mushroom stem beige column", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 216, "y": 18, "w": 18, "h": 18
  },
  { "name": "water-top", "tags": "water surface blue waves", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 234, "y": 18, "w": 18, "h": 18
  },
  { "name": "water-top-2", "tags": "water surface blue waves", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 252, "y": 18, "w": 18, "h": 18
  },
  { "name": "water-top-3", "tags": "water surface blue waves", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 270, "y": 18, "w": 18, "h": 18
  },
  { "name": "hedge-inner-left", "tags": "hedge bush green inner edge", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 288, "y": 18, "w": 18, "h": 18
  },
  { "name": "hedge-inner", "tags": "hedge bush green inner", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 306, "y": 18, "w": 18, "h": 18
  },
  { "name": "hedge-inner-2", "tags": "hedge bush green inner", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 324, "y": 18, "w": 18, "h": 18
  },
  { "name": "hedge-inner-right", "tags": "hedge bush green inner edge", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 342, "y": 18, "w": 18, "h": 18
  },
  { "name": "ground-sand-left", "tags": "ground sand beige platform top edge", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 0, "y": 36, "w": 18, "h": 18
  },
  { "name": "ground-sand", "tags": "ground sand beige platform top", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 18, "y": 36, "w": 18, "h": 18
  },
  { "name": "ground-sand-2", "tags": "ground sand beige platform top", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 36, "y": 36, "w": 18, "h": 18
  },
  { "name": "ground-sand-right", "tags": "ground sand beige platform top edge", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 54, "y": 36, "w": 18, "h": 18
  },
  { "name": "heart", "tags": "heart red health life full ui", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 72, "y": 36, "w": 18, "h": 18
  },
  { "name": "heart-half", "tags": "heart red health life half ui", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 90, "y": 36, "w": 18, "h": 18
  },
  { "name": "heart-empty", "tags": "heart health life empty ui", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 108, "y": 36, "w": 18, "h": 18
  },
  { "name": "plank-left", "tags": "plank wood bridge platform edge", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 126, "y": 36, "w": 18, "h": 18
  },
  { "name": "plank", "tags": "plank wood bridge platform", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 144, "y": 36, "w": 18, "h": 18
  },
  { "name": "plank-2", "tags": "plank wood bridge platform", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 162, "y": 36, "w": 18, "h": 18
  },
  { "name": "plank-right", "tags": "plank wood bridge platform edge", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 180, "y": 36, "w": 18, "h": 18
  },
  { "name": "ladder", "tags": "ladder wood climb", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 198, "y": 36, "w": 18, "h": 18
  },
  { "name": "mushroom-stem", "tags": "mushroom stem beige column", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 216, "y": 36, "w": 18, "h": 18
  },
  { "name": "water", "tags": "water blue", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 234, "y": 36, "w": 18, "h": 18
  },
  { "name": "waterfall", "tags": "waterfall water blue falling", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 252, "y": 36, "w": 18, "h": 18
  },
  { "name": "waterfall-2", "tags": "waterfall water blue falling", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 270, "y": 36, "w": 18, "h": 18
  },
  { "name": "hedge-lower-left", "tags": "hedge bush green lower edge", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 288, "y": 36, "w": 18, "h": 18
  },
  { "name": "hedge-lower", "tags": "hedge bush green lower", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 306, "y": 36, "w": 18, "h": 18
  },
  { "name": "hedge-lower-2", "tags": "hedge bush green lower", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 324, "y": 36, "w": 18, "h": 18
  },
  { "name": "hedge-lower-right", "tags": "hedge bush green lower edge", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 342, "y": 36, "w": 18, "h": 18
  },
  { "name": "ground-sand-corner-left", "tags": "ground sand beige corner edge", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 0, "y": 54, "w": 18, "h": 18
  },
  { "name": "ground-sand-inner", "tags": "ground sand beige inner", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 18, "y": 54, "w": 18, "h": 18
  },
  { "name": "ground-sand-inner-2", "tags": "ground sand beige inner", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 36, "y": 54, "w": 18, "h": 18
  },
  { "name": "ground-sand-corner-right", "tags": "ground sand beige corner edge", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 54, "y": 54, "w": 18, "h": 18
  },
  { "name": "lever-left", "tags": "lever switch red off", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 72, "y": 54, "w": 18, "h": 18
  },
  { "name": "lever-up", "tags": "lever switch red middle", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 90, "y": 54, "w": 18, "h": 18
  },
  { "name": "lever-right", "tags": "lever switch red on", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 108, "y": 54, "w": 18, "h": 18
  },
  { "name": "gem", "tags": "gem diamond blue crystal item treasure", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 126, "y": 54, "w": 18, "h": 18
  },
  { "name": "rocks", "tags": "rocks grey small pile", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 144, "y": 54, "w": 18, "h": 18
  },
  { "name": "pole-top", "tags": "pole post beige top", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 162, "y": 54, "w": 18, "h": 18
  },
  { "name": "hook", "tags": "hook ring grey arch", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 180, "y": 54, "w": 18, "h": 18
  },
  { "name": "ladder-2", "tags": "ladder wood climb", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 198, "y": 54, "w": 18, "h": 18
  },
  { "name": "mushroom-stem-2", "tags": "mushroom stem beige column", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 216, "y": 54, "w": 18, "h": 18
  },
  { "name": "water-2", "tags": "water blue", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 234, "y": 54, "w": 18, "h": 18
  },
  { "name": "waterfall-3", "tags": "waterfall water blue falling", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 252, "y": 54, "w": 18, "h": 18
  },
  { "name": "waterfall-4", "tags": "waterfall water blue falling", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 270, "y": 54, "w": 18, "h": 18
  },
  { "name": "hedge-bottom-left", "tags": "hedge bush green bottom edge", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 288, "y": 54, "w": 18, "h": 18
  },
  { "name": "hedge-bottom", "tags": "hedge bush green bottom", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 306, "y": 54, "w": 18, "h": 18
  },
  { "name": "hedge-bottom-2", "tags": "hedge bush green bottom", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 324, "y": 54, "w": 18, "h": 18
  },
  { "name": "hedge-bottom-right", "tags": "hedge bush green bottom edge", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 342, "y": 54, "w": 18, "h": 18
  },
  { "name": "ground-snow-left", "tags": "ground snow white platform top edge", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 0, "y": 72, "w": 18, "h": 18
  },
  { "name": "ground-snow", "tags": "ground snow white platform top", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 18, "y": 72, "w": 18, "h": 18
  },
  { "name": "ground-snow-2", "tags": "ground snow white platform top", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 36, "y": 72, "w": 18, "h": 18
  },
  { "name": "ground-snow-right", "tags": "ground snow white platform top edge", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 54, "y": 72, "w": 18, "h": 18
  },
  { "name": "sign", "tags": "sign wood board notice", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 72, "y": 72, "w": 18, "h": 18
  },
  { "name": "sign-2", "tags": "sign wood board notice", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 90, "y": 72, "w": 18, "h": 18
  },
  { "name": "sign-3", "tags": "sign wood board notice", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 108, "y": 72, "w": 18, "h": 18
  },
  { "name": "sign-arrow-left", "tags": "sign wood arrow left direction", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 126, "y": 72, "w": 18, "h": 18
  },
  { "name": "sign-arrow-right", "tags": "sign wood arrow right direction", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 144, "y": 72, "w": 18, "h": 18
  },
  { "name": "pole", "tags": "pole post thin beige", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 162, "y": 72, "w": 18, "h": 18
  },
  { "name": "rope-left", "tags": "rope bridge end", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 180, "y": 72, "w": 18, "h": 18
  },
  { "name": "rope", "tags": "rope bridge", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 198, "y": 72, "w": 18, "h": 18
  },
  { "name": "rope-right", "tags": "rope bridge end", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 216, "y": 72, "w": 18, "h": 18
  },
  { "name": "pipe-corner", "tags": "pipe blue corner", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 234, "y": 72, "w": 18, "h": 18
  },
  { "name": "pipe-end", "tags": "pipe blue end", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 252, "y": 72, "w": 18, "h": 18
  },
  { "name": "pipe-vertical", "tags": "pipe blue vertical", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 270, "y": 72, "w": 18, "h": 18
  },
  { "name": "leaves", "tags": "leaves green small foliage", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 288, "y": 72, "w": 18, "h": 18
  },
  { "name": "tree-top", "tags": "tree top green foliage trunk", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 306, "y": 72, "w": 18, "h": 18
  },
  { "name": "vine-leaves", "tags": "vine leaves green branch", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 324, "y": 72, "w": 18, "h": 18
  },
  { "name": "branch-leaves", "tags": "branch leaves green", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 342, "y": 72, "w": 18, "h": 18
  },
  { "name": "ground-snow-corner-left", "tags": "ground snow white corner edge", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 0, "y": 90, "w": 18, "h": 18
  },
  { "name": "ground-snow-inner", "tags": "ground snow white inner", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 18, "y": 90, "w": 18, "h": 18
  },
  { "name": "ground-snow-inner-2", "tags": "ground snow white inner", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 36, "y": 90, "w": 18, "h": 18
  },
  { "name": "ground-snow-corner-right", "tags": "ground snow white corner edge", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 54, "y": 90, "w": 18, "h": 18
  },
  { "name": "dirt-4", "tags": "dirt ground block brown", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 72, "y": 90, "w": 18, "h": 18
  },
  { "name": "fence-left", "tags": "fence wood edge", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 90, "y": 90, "w": 18, "h": 18
  },
  { "name": "fence-right", "tags": "fence wood edge", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 108, "y": 90, "w": 18, "h": 18
  },
  { "name": "mushroom-platform-small", "tags": "mushroom red platform small bouncy", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 126, "y": 90, "w": 18, "h": 18
  },
  { "name": "mushroom-platform", "tags": "mushroom red platform bouncy", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 144, "y": 90, "w": 18, "h": 18
  },
  { "name": "pole-2", "tags": "pole post thin beige", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 162, "y": 90, "w": 18, "h": 18
  },
  { "name": "pole-3", "tags": "pole post thin beige", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 180, "y": 90, "w": 18, "h": 18
  },
  { "name": "lava", "tags": "lava fire red hazard", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 198, "y": 90, "w": 18, "h": 18
  },
  { "name": "lava-2", "tags": "lava fire red hazard", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 216, "y": 90, "w": 18, "h": 18
  },
  { "name": "pipe-corner-2", "tags": "pipe blue corner", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 234, "y": 90, "w": 18, "h": 18
  },
  { "name": "pipe", "tags": "pipe blue", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 252, "y": 90, "w": 18, "h": 18
  },
  { "name": "pipe-vertical-2", "tags": "pipe blue vertical", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 270, "y": 90, "w": 18, "h": 18
  },
  { "name": "trunk", "tags": "trunk tree wood brown vertical", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 288, "y": 90, "w": 18, "h": 18
  },
  { "name": "trunk-branch", "tags": "trunk tree wood brown branch", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 306, "y": 90, "w": 18, "h": 18
  },
  { "name": "branch", "tags": "branch wood brown horizontal", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 324, "y": 90, "w": 18, "h": 18
  },
  { "name": "branch-2", "tags": "branch wood brown horizontal", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 342, "y": 90, "w": 18, "h": 18
  },
  { "name": "dirt-5", "tags": "dirt ground block brown", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 0, "y": 108, "w": 18, "h": 18
  },
  { "name": "dirt-6", "tags": "dirt ground block brown", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 18, "y": 108, "w": 18, "h": 18
  },
  { "name": "dirt-7", "tags": "dirt ground block brown", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 36, "y": 108, "w": 18, "h": 18
  },
  { "name": "dirt-8", "tags": "dirt ground block brown", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 54, "y": 108, "w": 18, "h": 18
  },
  { "name": "grass-plant", "tags": "grass plant green tufts", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 72, "y": 108, "w": 18, "h": 18
  },
  { "name": "tall-grass", "tags": "grass tall plant green", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 90, "y": 108, "w": 18, "h": 18
  },
  { "name": "pine-small", "tags": "pine tree small green", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 108, "y": 108, "w": 18, "h": 18
  },
  { "name": "cactus", "tags": "cactus desert green", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 126, "y": 108, "w": 18, "h": 18
  },
  { "name": "mushroom-red", "tags": "mushroom red toadstool", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 144, "y": 108, "w": 18, "h": 18
  },
  { "name": "lamp-post", "tags": "lamp post light beige", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 162, "y": 108, "w": 18, "h": 18
  },
  { "name": "door-top", "tags": "door brown window top", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 180, "y": 108, "w": 18, "h": 18
  },
  { "name": "pole-grey", "tags": "pole post grey thin", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 198, "y": 108, "w": 18, "h": 18
  },
  { "name": "pipe-horizontal-left", "tags": "pipe blue horizontal end", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 216, "y": 108, "w": 18, "h": 18
  },
  { "name": "pipe-horizontal", "tags": "pipe blue horizontal", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 234, "y": 108, "w": 18, "h": 18
  },
  { "name": "pipe-horizontal-right", "tags": "pipe blue horizontal end", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 252, "y": 108, "w": 18, "h": 18
  },
  { "name": "pipe-joint", "tags": "pipe blue joint vertical", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 270, "y": 108, "w": 18, "h": 18
  },
  { "name": "trunk-2", "tags": "trunk tree wood brown vertical", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 288, "y": 108, "w": 18, "h": 18
  },
  { "name": "trunk-fork", "tags": "trunk tree wood brown fork", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 306, "y": 108, "w": 18, "h": 18
  },
  { "name": "branch-3", "tags": "branch wood brown", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 324, "y": 108, "w": 18, "h": 18
  },
  { "name": "branch-end", "tags": "branch wood brown end", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 342, "y": 108, "w": 18, "h": 18
  },
  { "name": "dirt-9", "tags": "dirt ground block brown", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 0, "y": 126, "w": 18, "h": 18
  },
  { "name": "dirt-10", "tags": "dirt ground block brown", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 18, "y": 126, "w": 18, "h": 18
  },
  { "name": "dirt-11", "tags": "dirt ground block brown", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 36, "y": 126, "w": 18, "h": 18
  },
  { "name": "dirt-12", "tags": "dirt ground block brown", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 54, "y": 126, "w": 18, "h": 18
  },
  { "name": "snow-pile", "tags": "snow pile white small", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 72, "y": 126, "w": 18, "h": 18
  },
  { "name": "snowman", "tags": "snowman snow winter", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 90, "y": 126, "w": 18, "h": 18
  },
  { "name": "platform-wood", "tags": "platform wood small floating", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 108, "y": 126, "w": 18, "h": 18
  },
  { "name": "platform-sand", "tags": "platform beige small floating", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 126, "y": 126, "w": 18, "h": 18
  },
  { "name": "switch", "tags": "switch button blue pressure plate", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 144, "y": 126, "w": 18, "h": 18
  },
  { "name": "switch-pressed", "tags": "switch button blue pressed pressure plate", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 162, "y": 126, "w": 18, "h": 18
  },
  { "name": "door", "tags": "door brown wood exit", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 180, "y": 126, "w": 18, "h": 18
  },
  { "name": "coin", "tags": "coin gold round item", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 198, "y": 126, "w": 18, "h": 18
  },
  { "name": "coin-side", "tags": "coin gold edge spinning item", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 216, "y": 126, "w": 18, "h": 18
  },
  { "name": "cloud-left", "tags": "cloud white edge sky platform", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 234, "y": 126, "w": 18, "h": 18
  },
  { "name": "cloud", "tags": "cloud white sky platform", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 252, "y": 126, "w": 18, "h": 18
  },
  { "name": "cloud-right", "tags": "cloud white edge sky platform", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 270, "y": 126, "w": 18, "h": 18
  },
  { "name": "cloud-small", "tags": "cloud white small sky", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 288, "y": 126, "w": 18, "h": 18
  },
  { "name": "dot", "tags": "dot symbol small ui", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 306, "y": 126, "w": 18, "h": 18
  },
  { "name": "cross", "tags": "cross x symbol ui", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 324, "y": 126, "w": 18, "h": 18
  },
  { "name": "percent", "tags": "percent symbol ui", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 342, "y": 126, "w": 18, "h": 18
  },
  { "name": "digit-0", "tags": "digit number 0 grey ui", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 0, "y": 144, "w": 18, "h": 18
  },
  { "name": "digit-1", "tags": "digit number 1 grey ui", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 18, "y": 144, "w": 18, "h": 18
  },
  { "name": "digit-2", "tags": "digit number 2 grey ui", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 36, "y": 144, "w": 18, "h": 18
  },
  { "name": "digit-3", "tags": "digit number 3 grey ui", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 54, "y": 144, "w": 18, "h": 18
  },
  { "name": "digit-4", "tags": "digit number 4 grey ui", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 72, "y": 144, "w": 18, "h": 18
  },
  { "name": "digit-5", "tags": "digit number 5 grey ui", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 90, "y": 144, "w": 18, "h": 18
  },
  { "name": "digit-6", "tags": "digit number 6 grey ui", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 108, "y": 144, "w": 18, "h": 18
  },
  { "name": "digit-7", "tags": "digit number 7 grey ui", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 126, "y": 144, "w": 18, "h": 18
  },
  { "name": "digit-8", "tags": "digit number 8 grey ui", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 144, "y": 144, "w": 18, "h": 18
  },
  { "name": "digit-9", "tags": "digit number 9 grey ui", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 162, "y": 144, "w": 18, "h": 18
  },
  { "name": "digit-0-light", "tags": "digit number 0 white ui", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 180, "y": 144, "w": 18, "h": 18
  },
  { "name": "digit-1-light", "tags": "digit number 1 white ui", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 198, "y": 144, "w": 18, "h": 18
  },
  { "name": "digit-2-light", "tags": "digit number 2 white ui", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 216, "y": 144, "w": 18, "h": 18
  },
  { "name": "digit-3-light", "tags": "digit number 3 white ui", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 234, "y": 144, "w": 18, "h": 18
  },
  { "name": "digit-4-light", "tags": "digit number 4 white ui", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 252, "y": 144, "w": 18, "h": 18
  },
  { "name": "digit-5-light", "tags": "digit number 5 white ui", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 270, "y": 144, "w": 18, "h": 18
  },
  { "name": "digit-6-light", "tags": "digit number 6 white ui", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 288, "y": 144, "w": 18, "h": 18
  },
  { "name": "digit-7-light", "tags": "digit number 7 white ui", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 306, "y": 144, "w": 18, "h": 18
  },
  { "name": "digit-8-light", "tags": "digit number 8 white ui", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 324, "y": 144, "w": 18, "h": 18
  },
  { "name": "digit-9-light", "tags": "digit number 9 white ui", "pack": "platformer", "sheet": "platformer-tiles.png", "x": 342, "y": 144, "w": 18, "h": 18
  },
  { "name": "alien-green", "tags": "alien green helmet bubble character player idle", "pack": "platformer", "sheet": "platformer-characters.png", "x": 0, "y": 0, "w": 24, "h": 24
  },
  { "name": "alien-green-walk", "tags": "alien green helmet bubble character player walk", "pack": "platformer", "sheet": "platformer-characters.png", "x": 24, "y": 0, "w": 24, "h": 24
  },
  { "name": "alien-blue", "tags": "alien blue helmet bubble character player idle", "pack": "platformer", "sheet": "platformer-characters.png", "x": 48, "y": 0, "w": 24, "h": 24
  },
  { "name": "alien-blue-walk", "tags": "alien blue helmet bubble character player walk", "pack": "platformer", "sheet": "platformer-characters.png", "x": 72, "y": 0, "w": 24, "h": 24
  },
  { "name": "alien-pink", "tags": "alien pink cyclops one eye helmet character player idle", "pack": "platformer", "sheet": "platformer-characters.png", "x": 96, "y": 0, "w": 24, "h": 24
  },
  { "name": "alien-pink-walk", "tags": "alien pink cyclops helmet character player walk", "pack": "platformer", "sheet": "platformer-characters.png", "x": 120, "y": 0, "w": 24, "h": 24
  },
  { "name": "alien-yellow", "tags": "alien yellow helmet bubble character player idle", "pack": "platformer", "sheet": "platformer-characters.png", "x": 144, "y": 0, "w": 24, "h": 24
  },
  { "name": "alien-yellow-walk", "tags": "alien yellow helmet bubble character player walk", "pack": "platformer", "sheet": "platformer-characters.png", "x": 168, "y": 0, "w": 24, "h": 24
  },
  { "name": "spike-ball", "tags": "spike ball saw mine grey enemy hazard", "pack": "platformer", "sheet": "platformer-characters.png", "x": 192, "y": 0, "w": 24, "h": 24
  },
  { "name": "astronaut", "tags": "astronaut person helmet beige character player idle", "pack": "platformer", "sheet": "platformer-characters.png", "x": 0, "y": 24, "w": 24, "h": 24
  },
  { "name": "astronaut-walk", "tags": "astronaut person helmet beige character player walk", "pack": "platformer", "sheet": "platformer-characters.png", "x": 24, "y": 24, "w": 24, "h": 24
  },
  { "name": "block-face", "tags": "block face yellow angry enemy", "pack": "platformer", "sheet": "platformer-characters.png", "x": 48, "y": 24, "w": 24, "h": 24
  },
  { "name": "block-face-grin", "tags": "block face yellow grin enemy", "pack": "platformer", "sheet": "platformer-characters.png", "x": 72, "y": 24, "w": 24, "h": 24
  },
  { "name": "spark", "tags": "spark flame small orange creature enemy", "pack": "platformer", "sheet": "platformer-characters.png", "x": 96, "y": 24, "w": 24, "h": 24
  },
  { "name": "spark-2", "tags": "spark flame small orange creature enemy", "pack": "platformer", "sheet": "platformer-characters.png", "x": 120, "y": 24, "w": 24, "h": 24
  },
  { "name": "drill-bot", "tags": "robot drill orange spikes enemy idle", "pack": "platformer", "sheet": "platformer-characters.png", "x": 144, "y": 24, "w": 24, "h": 24
  },
  { "name": "drill-bot-2", "tags": "robot drill orange spikes enemy walk", "pack": "platformer", "sheet": "platformer-characters.png", "x": 168, "y": 24, "w": 24, "h": 24
  },
  { "name": "drill-bot-3", "tags": "robot drill orange spikes enemy walk", "pack": "platformer", "sheet": "platformer-characters.png", "x": 192, "y": 24, "w": 24, "h": 24
  },
  { "name": "mini-bot", "tags": "robot small blue enemy idle", "pack": "platformer", "sheet": "platformer-characters.png", "x": 0, "y": 48, "w": 24, "h": 24
  },
  { "name": "mini-bot-2", "tags": "robot small blue enemy walk", "pack": "platformer", "sheet": "platformer-characters.png", "x": 24, "y": 48, "w": 24, "h": 24
  },
  { "name": "mini-bot-3", "tags": "robot small blue enemy walk", "pack": "platformer", "sheet": "platformer-characters.png", "x": 48, "y": 48, "w": 24, "h": 24
  },
  { "name": "big-bot", "tags": "robot big blue enemy idle", "pack": "platformer", "sheet": "platformer-characters.png", "x": 72, "y": 48, "w": 24, "h": 24
  },
  { "name": "big-bot-2", "tags": "robot big blue enemy walk", "pack": "platformer", "sheet": "platformer-characters.png", "x": 96, "y": 48, "w": 24, "h": 24
  },
  { "name": "big-bot-3", "tags": "robot big blue enemy walk", "pack": "platformer", "sheet": "platformer-characters.png", "x": 120, "y": 48, "w": 24, "h": 24
  },
  { "name": "bat", "tags": "bat bird flying brown enemy wings up", "pack": "platformer", "sheet": "platformer-characters.png", "x": 144, "y": 48, "w": 24, "h": 24
  },
  { "name": "bat-2", "tags": "bat bird flying brown enemy wings flat", "pack": "platformer", "sheet": "platformer-characters.png", "x": 168, "y": 48, "w": 24, "h": 24
  },
  { "name": "bat-3", "tags": "bat bird flying brown enemy wings down", "pack": "platformer", "sheet": "platformer-characters.png", "x": 192, "y": 48, "w": 24, "h": 24
  },
  { "name": "sky-pale", "tags": "background sky pale blue plain", "pack": "platformer", "sheet": "platformer-backgrounds.png", "x": 0, "y": 0, "w": 24, "h": 24
  },
  { "name": "sky-pale-2", "tags": "background sky pale blue plain", "pack": "platformer", "sheet": "platformer-backgrounds.png", "x": 24, "y": 0, "w": 24, "h": 24
  },
  { "name": "sky-pale-3", "tags": "background sky pale blue plain", "pack": "platformer", "sheet": "platformer-backgrounds.png", "x": 48, "y": 0, "w": 24, "h": 24
  },
  { "name": "sky-pale-4", "tags": "background sky pale blue plain", "pack": "platformer", "sheet": "platformer-backgrounds.png", "x": 72, "y": 0, "w": 24, "h": 24
  },
  { "name": "sky-orange", "tags": "background sky orange sunset plain", "pack": "platformer", "sheet": "platformer-backgrounds.png", "x": 96, "y": 0, "w": 24, "h": 24
  },
  { "name": "sky-orange-2", "tags": "background sky orange sunset plain", "pack": "platformer", "sheet": "platformer-backgrounds.png", "x": 120, "y": 0, "w": 24, "h": 24
  },
  { "name": "sky-green", "tags": "background sky green plain", "pack": "platformer", "sheet": "platformer-backgrounds.png", "x": 144, "y": 0, "w": 24, "h": 24
  },
  { "name": "sky-green-2", "tags": "background sky green plain", "pack": "platformer", "sheet": "platformer-backgrounds.png", "x": 168, "y": 0, "w": 24, "h": 24
  },
  { "name": "hills-pale", "tags": "background hills clouds pale", "pack": "platformer", "sheet": "platformer-backgrounds.png", "x": 0, "y": 24, "w": 24, "h": 24
  },
  { "name": "hills-pale-trees", "tags": "background hills trees pale", "pack": "platformer", "sheet": "platformer-backgrounds.png", "x": 24, "y": 24, "w": 24, "h": 24
  },
  { "name": "hills-pale-2", "tags": "background hills clouds pale", "pack": "platformer", "sheet": "platformer-backgrounds.png", "x": 48, "y": 24, "w": 24, "h": 24
  },
  { "name": "hills-pale-pines", "tags": "background hills pine trees pale", "pack": "platformer", "sheet": "platformer-backgrounds.png", "x": 72, "y": 24, "w": 24, "h": 24
  },
  { "name": "hills-orange", "tags": "background hills desert orange", "pack": "platformer", "sheet": "platformer-backgrounds.png", "x": 96, "y": 24, "w": 24, "h": 24
  },
  { "name": "hills-orange-plants", "tags": "background hills desert plants orange", "pack": "platformer", "sheet": "platformer-backgrounds.png", "x": 120, "y": 24, "w": 24, "h": 24
  },
  { "name": "hills-green", "tags": "background hills forest green", "pack": "platformer", "sheet": "platformer-backgrounds.png", "x": 144, "y": 24, "w": 24, "h": 24
  },
  { "name": "hills-green-trees", "tags": "background hills forest trees green", "pack": "platformer", "sheet": "platformer-backgrounds.png", "x": 168, "y": 24, "w": 24, "h": 24
  },
  { "name": "ground-pale", "tags": "background ground pale plain", "pack": "platformer", "sheet": "platformer-backgrounds.png", "x": 0, "y": 48, "w": 24, "h": 24
  },
  { "name": "ground-pale-2", "tags": "background ground pale plain", "pack": "platformer", "sheet": "platformer-backgrounds.png", "x": 24, "y": 48, "w": 24, "h": 24
  },
  { "name": "ground-pale-3", "tags": "background ground pale plain", "pack": "platformer", "sheet": "platformer-backgrounds.png", "x": 48, "y": 48, "w": 24, "h": 24
  },
  { "name": "ground-pale-4", "tags": "background ground pale plain", "pack": "platformer", "sheet": "platformer-backgrounds.png", "x": 72, "y": 48, "w": 24, "h": 24
  },
  { "name": "ground-orange", "tags": "background ground desert brown plain", "pack": "platformer", "sheet": "platformer-backgrounds.png", "x": 96, "y": 48, "w": 24, "h": 24
  },
  { "name": "ground-orange-2", "tags": "background ground desert brown plain", "pack": "platformer", "sheet": "platformer-backgrounds.png", "x": 120, "y": 48, "w": 24, "h": 24
  },
  { "name": "ground-green", "tags": "background ground green plain", "pack": "platformer", "sheet": "platformer-backgrounds.png", "x": 144, "y": 48, "w": 24, "h": 24
  },
  { "name": "ground-green-2", "tags": "background ground green plain", "pack": "platformer", "sheet": "platformer-backgrounds.png", "x": 168, "y": 48, "w": 24, "h": 24
  },
  { "name": "emote", "tags": "emote reaction", "pack": "emotes", "sheet": "emotes.png", "x": 32, "y": 32, "w": 16, "h": 16
  },
  { "name": "emote-alert", "tags": "emote alert reaction", "pack": "emotes", "sheet": "emotes.png", "x": 64, "y": 64, "w": 16, "h": 16
  },
  { "name": "emote-anger", "tags": "emote anger reaction", "pack": "emotes", "sheet": "emotes.png", "x": 64, "y": 48, "w": 16, "h": 16
  },
  { "name": "emote-bars", "tags": "emote bars reaction", "pack": "emotes", "sheet": "emotes.png", "x": 64, "y": 32, "w": 16, "h": 16
  },
  { "name": "emote-cash", "tags": "emote cash reaction", "pack": "emotes", "sheet": "emotes.png", "x": 64, "y": 16, "w": 16, "h": 16
  },
  { "name": "emote-circle", "tags": "emote circle reaction", "pack": "emotes", "sheet": "emotes.png", "x": 64, "y": 0, "w": 16, "h": 16
  },
  { "name": "emote-cloud", "tags": "emote cloud reaction", "pack": "emotes", "sheet": "emotes.png", "x": 48, "y": 80, "w": 16, "h": 16
  },
  { "name": "emote-cross", "tags": "emote cross reaction", "pack": "emotes", "sheet": "emotes.png", "x": 48, "y": 64, "w": 16, "h": 16
  },
  { "name": "emote-dots-1", "tags": "emote dots 1 reaction", "pack": "emotes", "sheet": "emotes.png", "x": 48, "y": 48, "w": 16, "h": 16
  },
  { "name": "emote-dots-2", "tags": "emote dots 2 reaction", "pack": "emotes", "sheet": "emotes.png", "x": 48, "y": 32, "w": 16, "h": 16
  },
  { "name": "emote-dots-3", "tags": "emote dots 3 reaction", "pack": "emotes", "sheet": "emotes.png", "x": 48, "y": 16, "w": 16, "h": 16
  },
  { "name": "emote-drop", "tags": "emote drop reaction", "pack": "emotes", "sheet": "emotes.png", "x": 48, "y": 0, "w": 16, "h": 16
  },
  { "name": "emote-drops", "tags": "emote drops reaction", "pack": "emotes", "sheet": "emotes.png", "x": 32, "y": 80, "w": 16, "h": 16
  },
  { "name": "emote-exclamation", "tags": "emote exclamation reaction", "pack": "emotes", "sheet": "emotes.png", "x": 32, "y": 64, "w": 16, "h": 16
  },
  { "name": "emote-exclamations", "tags": "emote exclamations reaction", "pack": "emotes", "sheet": "emotes.png", "x": 32, "y": 48, "w": 16, "h": 16
  },
  { "name": "emote-face-angry", "tags": "emote face angry reaction", "pack": "emotes", "sheet": "emotes.png", "x": 64, "y": 80, "w": 16, "h": 16
  },
  { "name": "emote-face-happy", "tags": "emote face happy reaction", "pack": "emotes", "sheet": "emotes.png", "x": 32, "y": 16, "w": 16, "h": 16
  },
  { "name": "emote-face-sad", "tags": "emote face sad reaction", "pack": "emotes", "sheet": "emotes.png", "x": 32, "y": 0, "w": 16, "h": 16
  },
  { "name": "emote-heart", "tags": "emote heart reaction", "pack": "emotes", "sheet": "emotes.png", "x": 16, "y": 80, "w": 16, "h": 16
  },
  { "name": "emote-heart-broken", "tags": "emote heart broken reaction", "pack": "emotes", "sheet": "emotes.png", "x": 16, "y": 64, "w": 16, "h": 16
  },
  { "name": "emote-hearts", "tags": "emote hearts reaction", "pack": "emotes", "sheet": "emotes.png", "x": 16, "y": 48, "w": 16, "h": 16
  },
  { "name": "emote-idea", "tags": "emote idea reaction", "pack": "emotes", "sheet": "emotes.png", "x": 16, "y": 32, "w": 16, "h": 16
  },
  { "name": "emote-laugh", "tags": "emote laugh reaction", "pack": "emotes", "sheet": "emotes.png", "x": 16, "y": 16, "w": 16, "h": 16
  },
  { "name": "emote-music", "tags": "emote music reaction", "pack": "emotes", "sheet": "emotes.png", "x": 16, "y": 0, "w": 16, "h": 16
  },
  { "name": "emote-question", "tags": "emote question reaction", "pack": "emotes", "sheet": "emotes.png", "x": 0, "y": 80, "w": 16, "h": 16
  },
  { "name": "emote-sleep", "tags": "emote sleep reaction", "pack": "emotes", "sheet": "emotes.png", "x": 0, "y": 64, "w": 16, "h": 16
  },
  { "name": "emote-sleeps", "tags": "emote sleeps reaction", "pack": "emotes", "sheet": "emotes.png", "x": 0, "y": 48, "w": 16, "h": 16
  },
  { "name": "emote-star", "tags": "emote star reaction", "pack": "emotes", "sheet": "emotes.png", "x": 0, "y": 32, "w": 16, "h": 16
  },
  { "name": "emote-stars", "tags": "emote stars reaction", "pack": "emotes", "sheet": "emotes.png", "x": 0, "y": 16, "w": 16, "h": 16
  },
  { "name": "emote-swirl", "tags": "emote swirl reaction", "pack": "emotes", "sheet": "emotes.png", "x": 0, "y": 0, "w": 16, "h": 16
  },
  { "name": "beam-0", "tags": "beam 0", "pack": "space", "sheet": "space.png", "x": 143, "y": 377, "w": 43, "h": 31
  },
  { "name": "beam-1", "tags": "beam 1", "pack": "space", "sheet": "space.png", "x": 327, "y": 644, "w": 40, "h": 20
  },
  { "name": "beam-2", "tags": "beam 2", "pack": "space", "sheet": "space.png", "x": 262, "y": 907, "w": 38, "h": 31
  },
  { "name": "beam-3", "tags": "beam 3", "pack": "space", "sheet": "space.png", "x": 396, "y": 384, "w": 29, "h": 29
  },
  { "name": "beam-4", "tags": "beam 4", "pack": "space", "sheet": "space.png", "x": 177, "y": 496, "w": 41, "h": 17
  },
  { "name": "beam-5", "tags": "beam 5", "pack": "space", "sheet": "space.png", "x": 186, "y": 377, "w": 40, "h": 25
  },
  { "name": "beam-6", "tags": "beam 6", "pack": "space", "sheet": "space.png", "x": 120, "y": 688, "w": 43, "h": 23
  },
  { "name": "beam-long-1", "tags": "beam long 1", "pack": "space", "sheet": "space.png", "x": 828, "y": 943, "w": 15, "h": 67
  },
  { "name": "beam-long-2", "tags": "beam long 2", "pack": "space", "sheet": "space.png", "x": 307, "y": 309, "w": 25, "h": 64
  },
  { "name": "bold-silver", "tags": "bold silver", "pack": "space", "sheet": "space.png", "x": 810, "y": 837, "w": 19, "h": 30
  },
  { "name": "bolt-bronze", "tags": "bolt bronze", "pack": "space", "sheet": "space.png", "x": 810, "y": 467, "w": 19, "h": 30
  },
  { "name": "bolt-gold", "tags": "bolt gold", "pack": "space", "sheet": "space.png", "x": 809, "y": 437, "w": 19, "h": 30
  },
  { "name": "button-blue", "tags": "button blue", "pack": "space", "sheet": "space.png", "x": 0, "y": 78, "w": 222, "h": 39
  },
  { "name": "button-green", "tags": "button green", "pack": "space", "sheet": "space.png", "x": 0, "y": 117, "w": 222, "h": 39
  },
  { "name": "button-red", "tags": "button red", "pack": "space", "sheet": "space.png", "x": 0, "y": 0, "w": 222, "h": 39
  },
  { "name": "button-yellow", "tags": "button yellow", "pack": "space", "sheet": "space.png", "x": 0, "y": 39, "w": 222, "h": 39
  },
  { "name": "cockpit-blue-0", "tags": "cockpit blue 0", "pack": "space", "sheet": "space.png", "x": 586, "y": 0, "w": 51, "h": 75
  },
  { "name": "cockpit-blue-1", "tags": "cockpit blue 1", "pack": "space", "sheet": "space.png", "x": 736, "y": 862, "w": 40, "h": 40
  },
  { "name": "cockpit-blue-2", "tags": "cockpit blue 2", "pack": "space", "sheet": "space.png", "x": 684, "y": 67, "w": 42, "h": 56
  },
  { "name": "cockpit-blue-3", "tags": "cockpit blue 3", "pack": "space", "sheet": "space.png", "x": 336, "y": 384, "w": 60, "h": 61
  },
  { "name": "cockpit-blue-4", "tags": "cockpit blue 4", "pack": "space", "sheet": "space.png", "x": 637, "y": 0, "w": 47, "h": 67
  },
  { "name": "cockpit-blue-5", "tags": "cockpit blue 5", "pack": "space", "sheet": "space.png", "x": 627, "y": 144, "w": 48, "h": 75
  },
  { "name": "cockpit-blue-6", "tags": "cockpit blue 6", "pack": "space", "sheet": "space.png", "x": 684, "y": 0, "w": 42, "h": 67
  },
  { "name": "cockpit-blue-7", "tags": "cockpit blue 7", "pack": "space", "sheet": "space.png", "x": 737, "y": 542, "w": 41, "h": 71
  },
  { "name": "cockpit-green-0", "tags": "cockpit green 0", "pack": "space", "sheet": "space.png", "x": 576, "y": 225, "w": 51, "h": 75
  },
  { "name": "cockpit-green-1", "tags": "cockpit green 1", "pack": "space", "sheet": "space.png", "x": 734, "y": 977, "w": 40, "h": 40
  },
  { "name": "cockpit-green-2", "tags": "cockpit green 2", "pack": "space", "sheet": "space.png", "x": 696, "y": 659, "w": 42, "h": 56
  },
  { "name": "cockpit-green-3", "tags": "cockpit green 3", "pack": "space", "sheet": "space.png", "x": 346, "y": 234, "w": 60, "h": 61
  },
  { "name": "cockpit-green-4", "tags": "cockpit green 4", "pack": "space", "sheet": "space.png", "x": 627, "y": 219, "w": 47, "h": 67
  },
  { "name": "cockpit-green-5", "tags": "cockpit green 5", "pack": "space", "sheet": "space.png", "x": 694, "y": 364, "w": 42, "h": 67
  },
  { "name": "cockpit-green-6", "tags": "cockpit green 6", "pack": "space", "sheet": "space.png", "x": 737, "y": 471, "w": 41, "h": 71
  },
  { "name": "cockpit-green-7", "tags": "cockpit green 7", "pack": "space", "sheet": "space.png", "x": 602, "y": 525, "w": 48, "h": 75
  },
  { "name": "cockpit-red-0", "tags": "cockpit red 0", "pack": "space", "sheet": "space.png", "x": 535, "y": 75, "w": 51, "h": 75
  },
  { "name": "cockpit-red-1", "tags": "cockpit red 1", "pack": "space", "sheet": "space.png", "x": 351, "y": 982, "w": 40, "h": 40
  },
  { "name": "cockpit-red-2", "tags": "cockpit red 2", "pack": "space", "sheet": "space.png", "x": 718, "y": 197, "w": 42, "h": 56
  },
  { "name": "cockpit-red-3", "tags": "cockpit red 3", "pack": "space", "sheet": "space.png", "x": 520, "y": 661, "w": 60, "h": 61
  },
  { "name": "cockpit-red-4", "tags": "cockpit red 4", "pack": "space", "sheet": "space.png", "x": 647, "y": 857, "w": 47, "h": 67
  },
  { "name": "cockpit-red-5", "tags": "cockpit red 5", "pack": "space", "sheet": "space.png", "x": 605, "y": 707, "w": 48, "h": 75
  },
  { "name": "cockpit-red-6", "tags": "cockpit red 6", "pack": "space", "sheet": "space.png", "x": 736, "y": 795, "w": 42, "h": 67
  },
  { "name": "cockpit-red-7", "tags": "cockpit red 7", "pack": "space", "sheet": "space.png", "x": 736, "y": 329, "w": 41, "h": 71
  },
  { "name": "cockpit-yellow-0", "tags": "cockpit yellow 0", "pack": "space", "sheet": "space.png", "x": 726, "y": 80, "w": 40, "h": 40
  },
  { "name": "cockpit-yellow-1", "tags": "cockpit yellow 1", "pack": "space", "sheet": "space.png", "x": 247, "y": 309, "w": 60, "h": 61
  },
  { "name": "cockpit-yellow-2", "tags": "cockpit yellow 2", "pack": "space", "sheet": "space.png", "x": 637, "y": 67, "w": 47, "h": 67
  },
  { "name": "cockpit-yellow-3", "tags": "cockpit yellow 3", "pack": "space", "sheet": "space.png", "x": 607, "y": 782, "w": 48, "h": 75
  },
  { "name": "cockpit-yellow-4", "tags": "cockpit yellow 4", "pack": "space", "sheet": "space.png", "x": 696, "y": 262, "w": 42, "h": 67
  },
  { "name": "cockpit-yellow-5", "tags": "cockpit yellow 5", "pack": "space", "sheet": "space.png", "x": 736, "y": 400, "w": 41, "h": 71
  },
  { "name": "cockpit-yellow-6", "tags": "cockpit yellow 6", "pack": "space", "sheet": "space.png", "x": 734, "y": 921, "w": 42, "h": 56
  },
  { "name": "cockpit-yellow-7", "tags": "cockpit yellow 7", "pack": "space", "sheet": "space.png", "x": 600, "y": 375, "w": 51, "h": 75
  },
  { "name": "cursor", "tags": "cursor", "pack": "space", "sheet": "space.png", "x": 797, "y": 173, "w": 30, "h": 33
  },
  { "name": "enemy-black-1", "tags": "enemy black 1 ship alien", "pack": "space", "sheet": "space.png", "x": 423, "y": 728, "w": 93, "h": 84
  },
  { "name": "enemy-black-2", "tags": "enemy black 2 ship alien", "pack": "space", "sheet": "space.png", "x": 120, "y": 604, "w": 104, "h": 84
  },
  { "name": "enemy-black-3", "tags": "enemy black 3 ship alien", "pack": "space", "sheet": "space.png", "x": 144, "y": 156, "w": 103, "h": 84
  },
  { "name": "enemy-black-4", "tags": "enemy black 4 ship alien", "pack": "space", "sheet": "space.png", "x": 518, "y": 325, "w": 82, "h": 84
  },
  { "name": "enemy-black-5", "tags": "enemy black 5 ship alien", "pack": "space", "sheet": "space.png", "x": 346, "y": 150, "w": 97, "h": 84
  },
  { "name": "enemy-blue-1", "tags": "enemy blue 1 ship alien", "pack": "space", "sheet": "space.png", "x": 425, "y": 468, "w": 93, "h": 84
  },
  { "name": "enemy-blue-2", "tags": "enemy blue 2 ship alien", "pack": "space", "sheet": "space.png", "x": 143, "y": 293, "w": 104, "h": 84
  },
  { "name": "enemy-blue-3", "tags": "enemy blue 3 ship alien", "pack": "space", "sheet": "space.png", "x": 222, "y": 0, "w": 103, "h": 84
  },
  { "name": "enemy-blue-4", "tags": "enemy blue 4 ship alien", "pack": "space", "sheet": "space.png", "x": 518, "y": 409, "w": 82, "h": 84
  },
  { "name": "enemy-blue-5", "tags": "enemy blue 5 ship alien", "pack": "space", "sheet": "space.png", "x": 421, "y": 814, "w": 97, "h": 84
  },
  { "name": "enemy-green-1", "tags": "enemy green 1 ship alien", "pack": "space", "sheet": "space.png", "x": 425, "y": 552, "w": 93, "h": 84
  },
  { "name": "enemy-green-2", "tags": "enemy green 2 ship alien", "pack": "space", "sheet": "space.png", "x": 133, "y": 412, "w": 104, "h": 84
  },
  { "name": "enemy-green-3", "tags": "enemy green 3 ship alien", "pack": "space", "sheet": "space.png", "x": 224, "y": 496, "w": 103, "h": 84
  },
  { "name": "enemy-green-4", "tags": "enemy green 4 ship alien", "pack": "space", "sheet": "space.png", "x": 518, "y": 493, "w": 82, "h": 84
  },
  { "name": "enemy-green-5", "tags": "enemy green 5 ship alien", "pack": "space", "sheet": "space.png", "x": 408, "y": 907, "w": 97, "h": 84
  },
  { "name": "enemy-red-1", "tags": "enemy red 1 ship alien", "pack": "space", "sheet": "space.png", "x": 425, "y": 384, "w": 93, "h": 84
  },
  { "name": "enemy-red-2", "tags": "enemy red 2 ship alien", "pack": "space", "sheet": "space.png", "x": 120, "y": 520, "w": 104, "h": 84
  },
  { "name": "enemy-red-3", "tags": "enemy red 3 ship alien", "pack": "space", "sheet": "space.png", "x": 224, "y": 580, "w": 103, "h": 84
  },
  { "name": "enemy-red-4", "tags": "enemy red 4 ship alien", "pack": "space", "sheet": "space.png", "x": 520, "y": 577, "w": 82, "h": 84
  },
  { "name": "enemy-red-5", "tags": "enemy red 5 ship alien", "pack": "space", "sheet": "space.png", "x": 423, "y": 644, "w": 97, "h": 84
  },
  { "name": "engine-1", "tags": "engine 1", "pack": "space", "sheet": "space.png", "x": 224, "y": 907, "w": 38, "h": 23
  },
  { "name": "engine-2", "tags": "engine 2", "pack": "space", "sheet": "space.png", "x": 163, "y": 688, "w": 42, "h": 28
  },
  { "name": "engine-3", "tags": "engine 3", "pack": "space", "sheet": "space.png", "x": 644, "y": 1002, "w": 27, "h": 22
  },
  { "name": "engine-4", "tags": "engine 4", "pack": "space", "sheet": "space.png", "x": 144, "y": 240, "w": 49, "h": 45
  },
  { "name": "engine-5", "tags": "engine 5", "pack": "space", "sheet": "space.png", "x": 133, "y": 496, "w": 44, "h": 24
  },
  { "name": "fire-00", "tags": "fire 00", "pack": "space", "sheet": "space.png", "x": 827, "y": 125, "w": 16, "h": 40
  },
  { "name": "fire-01", "tags": "fire 01", "pack": "space", "sheet": "space.png", "x": 828, "y": 206, "w": 14, "h": 31
  },
  { "name": "fire-02", "tags": "fire 02", "pack": "space", "sheet": "space.png", "x": 827, "y": 663, "w": 14, "h": 32
  },
  { "name": "fire-03", "tags": "fire 03", "pack": "space", "sheet": "space.png", "x": 829, "y": 437, "w": 14, "h": 34
  },
  { "name": "fire-04", "tags": "fire 04", "pack": "space", "sheet": "space.png", "x": 831, "y": 0, "w": 14, "h": 31
  },
  { "name": "fire-05", "tags": "fire 05", "pack": "space", "sheet": "space.png", "x": 834, "y": 299, "w": 14, "h": 31
  },
  { "name": "fire-06", "tags": "fire 06", "pack": "space", "sheet": "space.png", "x": 835, "y": 502, "w": 14, "h": 31
  },
  { "name": "fire-07", "tags": "fire 07", "pack": "space", "sheet": "space.png", "x": 835, "y": 330, "w": 14, "h": 31
  },
  { "name": "fire-08", "tags": "fire 08", "pack": "space", "sheet": "space.png", "x": 827, "y": 867, "w": 16, "h": 40
  },
  { "name": "fire-09", "tags": "fire 09", "pack": "space", "sheet": "space.png", "x": 811, "y": 663, "w": 16, "h": 40
  },
  { "name": "fire-10", "tags": "fire 10", "pack": "space", "sheet": "space.png", "x": 812, "y": 206, "w": 16, "h": 40
  },
  { "name": "fire-11", "tags": "fire 11", "pack": "space", "sheet": "space.png", "x": 835, "y": 395, "w": 14, "h": 31
  },
  { "name": "fire-12", "tags": "fire 12", "pack": "space", "sheet": "space.png", "x": 835, "y": 533, "w": 14, "h": 32
  },
  { "name": "fire-13", "tags": "fire 13", "pack": "space", "sheet": "space.png", "x": 835, "y": 361, "w": 14, "h": 34
  },
  { "name": "fire-14", "tags": "fire 14", "pack": "space", "sheet": "space.png", "x": 831, "y": 31, "w": 14, "h": 31
  },
  { "name": "fire-15", "tags": "fire 15", "pack": "space", "sheet": "space.png", "x": 829, "y": 471, "w": 14, "h": 31
  },
  { "name": "fire-16", "tags": "fire 16", "pack": "space", "sheet": "space.png", "x": 828, "y": 268, "w": 14, "h": 31
  },
  { "name": "fire-17", "tags": "fire 17", "pack": "space", "sheet": "space.png", "x": 828, "y": 237, "w": 14, "h": 31
  },
  { "name": "fire-18", "tags": "fire 18", "pack": "space", "sheet": "space.png", "x": 827, "y": 165, "w": 16, "h": 41
  },
  { "name": "fire-19", "tags": "fire 19", "pack": "space", "sheet": "space.png", "x": 812, "y": 246, "w": 16, "h": 41
  },
  { "name": "gun-00", "tags": "gun 00 pistol", "pack": "space", "sheet": "space.png", "x": 827, "y": 907, "w": 16, "h": 36
  },
  { "name": "gun-01", "tags": "gun 01 pistol", "pack": "space", "sheet": "space.png", "x": 810, "y": 867, "w": 17, "h": 33
  },
  { "name": "gun-02", "tags": "gun 02 pistol", "pack": "space", "sheet": "space.png", "x": 829, "y": 611, "w": 14, "h": 36
  },
  { "name": "gun-03", "tags": "gun 03 pistol", "pack": "space", "sheet": "space.png", "x": 809, "y": 796, "w": 20, "h": 41
  },
  { "name": "gun-04", "tags": "gun 04 pistol", "pack": "space", "sheet": "space.png", "x": 827, "y": 84, "w": 16, "h": 41
  },
  { "name": "gun-05", "tags": "gun 05 pistol", "pack": "space", "sheet": "space.png", "x": 423, "y": 0, "w": 21, "h": 41
  },
  { "name": "gun-06", "tags": "gun 06 pistol", "pack": "space", "sheet": "space.png", "x": 810, "y": 900, "w": 17, "h": 38
  },
  { "name": "gun-07", "tags": "gun 07 pistol", "pack": "space", "sheet": "space.png", "x": 829, "y": 796, "w": 14, "h": 41
  },
  { "name": "gun-08", "tags": "gun 08 pistol", "pack": "space", "sheet": "space.png", "x": 848, "y": 263, "w": 10, "h": 47
  },
  { "name": "gun-09", "tags": "gun 09 pistol", "pack": "space", "sheet": "space.png", "x": 809, "y": 611, "w": 20, "h": 52
  },
  { "name": "gun-10", "tags": "gun 10 pistol", "pack": "space", "sheet": "space.png", "x": 808, "y": 961, "w": 20, "h": 52
  },
  { "name": "laser-blue-01", "tags": "laser blue 01 bullet shot", "pack": "space", "sheet": "space.png", "x": 856, "y": 421, "w": 9, "h": 54
  },
  { "name": "laser-blue-02", "tags": "laser blue 02 bullet shot", "pack": "space", "sheet": "space.png", "x": 841, "y": 647, "w": 13, "h": 37
  },
  { "name": "laser-blue-03", "tags": "laser blue 03 bullet shot", "pack": "space", "sheet": "space.png", "x": 856, "y": 57, "w": 9, "h": 37
  },
  { "name": "laser-blue-04", "tags": "laser blue 04 bullet shot", "pack": "space", "sheet": "space.png", "x": 835, "y": 565, "w": 13, "h": 37
  },
  { "name": "laser-blue-05", "tags": "laser blue 05 bullet shot", "pack": "space", "sheet": "space.png", "x": 858, "y": 475, "w": 9, "h": 37
  },
  { "name": "laser-blue-06", "tags": "laser blue 06 bullet shot", "pack": "space", "sheet": "space.png", "x": 835, "y": 752, "w": 13, "h": 37
  },
  { "name": "laser-blue-07", "tags": "laser blue 07 bullet shot", "pack": "space", "sheet": "space.png", "x": 856, "y": 775, "w": 9, "h": 37
  },
  { "name": "laser-blue-08", "tags": "laser blue 08 bullet shot", "pack": "space", "sheet": "space.png", "x": 596, "y": 961, "w": 48, "h": 46
  },
  { "name": "laser-blue-09", "tags": "laser blue 09 bullet shot", "pack": "space", "sheet": "space.png", "x": 434, "y": 325, "w": 48, "h": 46
  },
  { "name": "laser-blue-10", "tags": "laser blue 10 bullet shot", "pack": "space", "sheet": "space.png", "x": 740, "y": 724, "w": 37, "h": 37
  },
  { "name": "laser-blue-11", "tags": "laser blue 11 bullet shot", "pack": "space", "sheet": "space.png", "x": 698, "y": 795, "w": 38, "h": 37
  },
  { "name": "laser-blue-12", "tags": "laser blue 12 bullet shot", "pack": "space", "sheet": "space.png", "x": 835, "y": 695, "w": 13, "h": 57
  },
  { "name": "laser-blue-13", "tags": "laser blue 13 bullet shot", "pack": "space", "sheet": "space.png", "x": 856, "y": 869, "w": 9, "h": 57
  },
  { "name": "laser-blue-14", "tags": "laser blue 14 bullet shot", "pack": "space", "sheet": "space.png", "x": 842, "y": 206, "w": 13, "h": 57
  },
  { "name": "laser-blue-15", "tags": "laser blue 15 bullet shot", "pack": "space", "sheet": "space.png", "x": 849, "y": 480, "w": 9, "h": 57
  },
  { "name": "laser-blue-16", "tags": "laser blue 16 bullet shot", "pack": "space", "sheet": "space.png", "x": 843, "y": 62, "w": 13, "h": 54
  },
  { "name": "laser-green-01", "tags": "laser green 01 bullet shot", "pack": "space", "sheet": "space.png", "x": 740, "y": 686, "w": 37, "h": 38
  },
  { "name": "laser-green-02", "tags": "laser green 02 bullet shot", "pack": "space", "sheet": "space.png", "x": 843, "y": 116, "w": 13, "h": 57
  },
  { "name": "laser-green-03", "tags": "laser green 03 bullet shot", "pack": "space", "sheet": "space.png", "x": 855, "y": 173, "w": 9, "h": 57
  },
  { "name": "laser-green-04", "tags": "laser green 04 bullet shot", "pack": "space", "sheet": "space.png", "x": 848, "y": 565, "w": 13, "h": 37
  },
  { "name": "laser-green-05", "tags": "laser green 05 bullet shot", "pack": "space", "sheet": "space.png", "x": 854, "y": 639, "w": 9, "h": 37
  },
  { "name": "laser-green-06", "tags": "laser green 06 bullet shot", "pack": "space", "sheet": "space.png", "x": 845, "y": 0, "w": 13, "h": 57
  },
  { "name": "laser-green-07", "tags": "laser green 07 bullet shot", "pack": "space", "sheet": "space.png", "x": 849, "y": 364, "w": 9, "h": 57
  },
  { "name": "laser-green-08", "tags": "laser green 08 bullet shot", "pack": "space", "sheet": "space.png", "x": 848, "y": 738, "w": 13, "h": 37
  },
  { "name": "laser-green-09", "tags": "laser green 09 bullet shot", "pack": "space", "sheet": "space.png", "x": 856, "y": 94, "w": 9, "h": 37
  },
  { "name": "laser-green-10", "tags": "laser green 10 bullet shot", "pack": "space", "sheet": "space.png", "x": 843, "y": 426, "w": 13, "h": 54
  },
  { "name": "laser-green-11", "tags": "laser green 11 bullet shot", "pack": "space", "sheet": "space.png", "x": 849, "y": 310, "w": 9, "h": 54
  },
  { "name": "laser-green-12", "tags": "laser green 12 bullet shot", "pack": "space", "sheet": "space.png", "x": 843, "y": 602, "w": 13, "h": 37
  },
  { "name": "laser-green-13", "tags": "laser green 13 bullet shot", "pack": "space", "sheet": "space.png", "x": 858, "y": 0, "w": 9, "h": 37
  },
  { "name": "laser-green-14", "tags": "laser green 14 bullet shot", "pack": "space", "sheet": "space.png", "x": 193, "y": 240, "w": 48, "h": 46
  },
  { "name": "laser-green-15", "tags": "laser green 15 bullet shot", "pack": "space", "sheet": "space.png", "x": 443, "y": 182, "w": 48, "h": 46
  },
  { "name": "laser-green-16", "tags": "laser green 16 bullet shot", "pack": "space", "sheet": "space.png", "x": 760, "y": 192, "w": 37, "h": 37
  },
  { "name": "laser-red-01", "tags": "laser red 01 bullet shot", "pack": "space", "sheet": "space.png", "x": 858, "y": 230, "w": 9, "h": 54
  },
  { "name": "laser-red-02", "tags": "laser red 02 bullet shot", "pack": "space", "sheet": "space.png", "x": 843, "y": 977, "w": 13, "h": 37
  },
  { "name": "laser-red-03", "tags": "laser red 03 bullet shot", "pack": "space", "sheet": "space.png", "x": 856, "y": 602, "w": 9, "h": 37
  },
  { "name": "laser-red-04", "tags": "laser red 04 bullet shot", "pack": "space", "sheet": "space.png", "x": 843, "y": 940, "w": 13, "h": 37
  },
  { "name": "laser-red-05", "tags": "laser red 05 bullet shot", "pack": "space", "sheet": "space.png", "x": 856, "y": 983, "w": 9, "h": 37
  },
  { "name": "laser-red-06", "tags": "laser red 06 bullet shot", "pack": "space", "sheet": "space.png", "x": 843, "y": 903, "w": 13, "h": 37
  },
  { "name": "laser-red-07", "tags": "laser red 07 bullet shot", "pack": "space", "sheet": "space.png", "x": 856, "y": 131, "w": 9, "h": 37
  },
  { "name": "laser-red-08", "tags": "laser red 08 bullet shot", "pack": "space", "sheet": "space.png", "x": 580, "y": 661, "w": 48, "h": 46
  },
  { "name": "laser-red-09", "tags": "laser red 09 bullet shot", "pack": "space", "sheet": "space.png", "x": 602, "y": 600, "w": 48, "h": 46
  },
  { "name": "laser-red-10", "tags": "laser red 10 bullet shot", "pack": "space", "sheet": "space.png", "x": 738, "y": 650, "w": 37, "h": 36
  },
  { "name": "laser-red-11", "tags": "laser red 11 bullet shot", "pack": "space", "sheet": "space.png", "x": 737, "y": 613, "w": 37, "h": 37
  },
  { "name": "laser-red-12", "tags": "laser red 12 bullet shot", "pack": "space", "sheet": "space.png", "x": 843, "y": 846, "w": 13, "h": 57
  },
  { "name": "laser-red-13", "tags": "laser red 13 bullet shot", "pack": "space", "sheet": "space.png", "x": 856, "y": 812, "w": 9, "h": 57
  },
  { "name": "laser-red-14", "tags": "laser red 14 bullet shot", "pack": "space", "sheet": "space.png", "x": 843, "y": 789, "w": 13, "h": 57
  },
  { "name": "laser-red-15", "tags": "laser red 15 bullet shot", "pack": "space", "sheet": "space.png", "x": 856, "y": 926, "w": 9, "h": 57
  },
  { "name": "laser-red-16", "tags": "laser red 16 bullet shot", "pack": "space", "sheet": "space.png", "x": 848, "y": 684, "w": 13, "h": 54
  },
  { "name": "meteor-brown-big-1", "tags": "meteor brown big 1 asteroid rock", "pack": "space", "sheet": "space.png", "x": 224, "y": 664, "w": 101, "h": 84
  },
  { "name": "meteor-brown-big-2", "tags": "meteor brown big 2 asteroid rock", "pack": "space", "sheet": "space.png", "x": 0, "y": 520, "w": 120, "h": 98
  },
  { "name": "meteor-brown-big-3", "tags": "meteor brown big 3 asteroid rock", "pack": "space", "sheet": "space.png", "x": 518, "y": 810, "w": 89, "h": 82
  },
  { "name": "meteor-brown-big-4", "tags": "meteor brown big 4 asteroid rock", "pack": "space", "sheet": "space.png", "x": 327, "y": 452, "w": 98, "h": 96
  },
  { "name": "meteor-brown-med-1", "tags": "meteor brown med 1 asteroid rock", "pack": "space", "sheet": "space.png", "x": 651, "y": 447, "w": 43, "h": 43
  },
  { "name": "meteor-brown-med-3", "tags": "meteor brown med 3 asteroid rock", "pack": "space", "sheet": "space.png", "x": 237, "y": 452, "w": 45, "h": 40
  },
  { "name": "meteor-brown-small-1", "tags": "meteor brown small 1 asteroid rock", "pack": "space", "sheet": "space.png", "x": 406, "y": 234, "w": 28, "h": 28
  },
  { "name": "meteor-brown-small-2", "tags": "meteor brown small 2 asteroid rock", "pack": "space", "sheet": "space.png", "x": 778, "y": 587, "w": 29, "h": 26
  },
  { "name": "meteor-brown-tiny-1", "tags": "meteor brown tiny 1 asteroid rock", "pack": "space", "sheet": "space.png", "x": 346, "y": 814, "w": 18, "h": 18
  },
  { "name": "meteor-brown-tiny-2", "tags": "meteor brown tiny 2 asteroid rock", "pack": "space", "sheet": "space.png", "x": 399, "y": 814, "w": 16, "h": 15
  },
  { "name": "meteor-grey-big-1", "tags": "meteor grey big 1 asteroid rock", "pack": "space", "sheet": "space.png", "x": 224, "y": 748, "w": 101, "h": 84
  },
  { "name": "meteor-grey-big-2", "tags": "meteor grey big 2 asteroid rock", "pack": "space", "sheet": "space.png", "x": 0, "y": 618, "w": 120, "h": 98
  },
  { "name": "meteor-grey-big-3", "tags": "meteor grey big 3 asteroid rock", "pack": "space", "sheet": "space.png", "x": 516, "y": 728, "w": 89, "h": 82
  },
  { "name": "meteor-grey-big-4", "tags": "meteor grey big 4 asteroid rock", "pack": "space", "sheet": "space.png", "x": 327, "y": 548, "w": 98, "h": 96
  },
  { "name": "meteor-grey-med-1", "tags": "meteor grey med 1 asteroid rock", "pack": "space", "sheet": "space.png", "x": 674, "y": 219, "w": 43, "h": 43
  },
  { "name": "meteor-grey-med-2", "tags": "meteor grey med 2 asteroid rock", "pack": "space", "sheet": "space.png", "x": 282, "y": 452, "w": 45, "h": 40
  },
  { "name": "meteor-grey-small-1", "tags": "meteor grey small 1 asteroid rock", "pack": "space", "sheet": "space.png", "x": 406, "y": 262, "w": 28, "h": 28
  },
  { "name": "meteor-grey-small-2", "tags": "meteor grey small 2 asteroid rock", "pack": "space", "sheet": "space.png", "x": 396, "y": 413, "w": 29, "h": 26
  },
  { "name": "meteor-grey-tiny-1", "tags": "meteor grey tiny 1 asteroid rock", "pack": "space", "sheet": "space.png", "x": 364, "y": 814, "w": 18, "h": 18
  },
  { "name": "meteor-grey-tiny-2", "tags": "meteor grey tiny 2 asteroid rock", "pack": "space", "sheet": "space.png", "x": 602, "y": 646, "w": 16, "h": 15
  },
  { "name": "numeral-0", "tags": "numeral 0", "pack": "space", "sheet": "space.png", "x": 367, "y": 644, "w": 19, "h": 19
  },
  { "name": "numeral-1", "tags": "numeral 1", "pack": "space", "sheet": "space.png", "x": 205, "y": 688, "w": 19, "h": 19
  },
  { "name": "numeral-2", "tags": "numeral 2", "pack": "space", "sheet": "space.png", "x": 406, "y": 290, "w": 19, "h": 19
  },
  { "name": "numeral-3", "tags": "numeral 3", "pack": "space", "sheet": "space.png", "x": 580, "y": 707, "w": 19, "h": 19
  },
  { "name": "numeral-4", "tags": "numeral 4", "pack": "space", "sheet": "space.png", "x": 386, "y": 644, "w": 19, "h": 19
  },
  { "name": "numeral-5", "tags": "numeral 5", "pack": "space", "sheet": "space.png", "x": 628, "y": 646, "w": 19, "h": 19
  },
  { "name": "numeral-6", "tags": "numeral 6", "pack": "space", "sheet": "space.png", "x": 671, "y": 1002, "w": 19, "h": 19
  },
  { "name": "numeral-7", "tags": "numeral 7", "pack": "space", "sheet": "space.png", "x": 690, "y": 1004, "w": 19, "h": 19
  },
  { "name": "numeral-8", "tags": "numeral 8", "pack": "space", "sheet": "space.png", "x": 709, "y": 1004, "w": 19, "h": 19
  },
  { "name": "numeral-9", "tags": "numeral 9", "pack": "space", "sheet": "space.png", "x": 491, "y": 215, "w": 19, "h": 19
  },
  { "name": "numeral-x", "tags": "numeral x", "pack": "space", "sheet": "space.png", "x": 382, "y": 814, "w": 17, "h": 17
  },
  { "name": "pill-blue", "tags": "pill blue", "pack": "space", "sheet": "space.png", "x": 674, "y": 262, "w": 22, "h": 21
  },
  { "name": "pill-green", "tags": "pill green", "pack": "space", "sheet": "space.png", "x": 573, "y": 989, "w": 22, "h": 21
  },
  { "name": "pill-red", "tags": "pill red", "pack": "space", "sheet": "space.png", "x": 222, "y": 108, "w": 22, "h": 21
  },
  { "name": "pill-yellow", "tags": "pill yellow", "pack": "space", "sheet": "space.png", "x": 222, "y": 129, "w": 22, "h": 21
  },
  { "name": "player-life-1-blue", "tags": "player life 1 blue ship", "pack": "space", "sheet": "space.png", "x": 482, "y": 358, "w": 33, "h": 26
  },
  { "name": "player-life-1-green", "tags": "player life 1 green ship", "pack": "space", "sheet": "space.png", "x": 535, "y": 150, "w": 33, "h": 26
  },
  { "name": "player-life-1-orange", "tags": "player life 1 orange ship", "pack": "space", "sheet": "space.png", "x": 777, "y": 327, "w": 33, "h": 26
  },
  { "name": "player-life-1-red", "tags": "player life 1 red ship", "pack": "space", "sheet": "space.png", "x": 775, "y": 301, "w": 33, "h": 26
  },
  { "name": "player-life-2-blue", "tags": "player life 2 blue ship", "pack": "space", "sheet": "space.png", "x": 465, "y": 991, "w": 37, "h": 26
  },
  { "name": "player-life-2-green", "tags": "player life 2 green ship", "pack": "space", "sheet": "space.png", "x": 391, "y": 991, "w": 37, "h": 26
  },
  { "name": "player-life-2-orange", "tags": "player life 2 orange ship", "pack": "space", "sheet": "space.png", "x": 428, "y": 991, "w": 37, "h": 26
  },
  { "name": "player-life-2-red", "tags": "player life 2 red ship", "pack": "space", "sheet": "space.png", "x": 502, "y": 991, "w": 37, "h": 26
  },
  { "name": "player-life-3-blue", "tags": "player life 3 blue ship", "pack": "space", "sheet": "space.png", "x": 777, "y": 385, "w": 32, "h": 26
  },
  { "name": "player-life-3-green", "tags": "player life 3 green ship", "pack": "space", "sheet": "space.png", "x": 778, "y": 469, "w": 32, "h": 26
  },
  { "name": "player-life-3-orange", "tags": "player life 3 orange ship", "pack": "space", "sheet": "space.png", "x": 777, "y": 712, "w": 32, "h": 26
  },
  { "name": "player-life-3-red", "tags": "player life 3 red ship", "pack": "space", "sheet": "space.png", "x": 777, "y": 443, "w": 32, "h": 26
  },
  { "name": "player-ship-1-blue", "tags": "player ship 1 blue ship", "pack": "space", "sheet": "space.png", "x": 211, "y": 941, "w": 99, "h": 75
  },
  { "name": "player-ship-1-damage-1", "tags": "player ship 1 damage 1 ship", "pack": "space", "sheet": "space.png", "x": 112, "y": 941, "w": 99, "h": 75
  },
  { "name": "player-ship-1-damage-2", "tags": "player ship 1 damage 2 ship", "pack": "space", "sheet": "space.png", "x": 247, "y": 234, "w": 99, "h": 75
  },
  { "name": "player-ship-1-damage-3", "tags": "player ship 1 damage 3 ship", "pack": "space", "sheet": "space.png", "x": 247, "y": 159, "w": 99, "h": 75
  },
  { "name": "player-ship-1-green", "tags": "player ship 1 green ship", "pack": "space", "sheet": "space.png", "x": 237, "y": 377, "w": 99, "h": 75
  },
  { "name": "player-ship-1-orange", "tags": "player ship 1 orange ship", "pack": "space", "sheet": "space.png", "x": 247, "y": 84, "w": 99, "h": 75
  },
  { "name": "player-ship-1-red", "tags": "player ship 1 red ship", "pack": "space", "sheet": "space.png", "x": 224, "y": 832, "w": 99, "h": 75
  },
  { "name": "player-ship-2-blue", "tags": "player ship 2 blue ship", "pack": "space", "sheet": "space.png", "x": 112, "y": 791, "w": 112, "h": 75
  },
  { "name": "player-ship-2-damage-1", "tags": "player ship 2 damage 1 ship", "pack": "space", "sheet": "space.png", "x": 0, "y": 866, "w": 112, "h": 75
  },
  { "name": "player-ship-2-damage-2", "tags": "player ship 2 damage 2 ship", "pack": "space", "sheet": "space.png", "x": 0, "y": 791, "w": 112, "h": 75
  },
  { "name": "player-ship-2-damage-3", "tags": "player ship 2 damage 3 ship", "pack": "space", "sheet": "space.png", "x": 0, "y": 716, "w": 112, "h": 75
  },
  { "name": "player-ship-2-green", "tags": "player ship 2 green ship", "pack": "space", "sheet": "space.png", "x": 112, "y": 866, "w": 112, "h": 75
  },
  { "name": "player-ship-2-orange", "tags": "player ship 2 orange ship", "pack": "space", "sheet": "space.png", "x": 112, "y": 716, "w": 112, "h": 75
  },
  { "name": "player-ship-2-red", "tags": "player ship 2 red ship", "pack": "space", "sheet": "space.png", "x": 0, "y": 941, "w": 112, "h": 75
  },
  { "name": "player-ship-3-blue", "tags": "player ship 3 blue ship", "pack": "space", "sheet": "space.png", "x": 325, "y": 739, "w": 98, "h": 75
  },
  { "name": "player-ship-3-damage-1", "tags": "player ship 3 damage 1 ship", "pack": "space", "sheet": "space.png", "x": 323, "y": 832, "w": 98, "h": 75
  },
  { "name": "player-ship-3-damage-2", "tags": "player ship 3 damage 2 ship", "pack": "space", "sheet": "space.png", "x": 310, "y": 907, "w": 98, "h": 75
  },
  { "name": "player-ship-3-damage-3", "tags": "player ship 3 damage 3 ship", "pack": "space", "sheet": "space.png", "x": 325, "y": 664, "w": 98, "h": 75
  },
  { "name": "player-ship-3-green", "tags": "player ship 3 green ship", "pack": "space", "sheet": "space.png", "x": 346, "y": 75, "w": 98, "h": 75
  },
  { "name": "player-ship-3-orange", "tags": "player ship 3 orange ship", "pack": "space", "sheet": "space.png", "x": 336, "y": 309, "w": 98, "h": 75
  },
  { "name": "player-ship-3-red", "tags": "player ship 3 red ship", "pack": "space", "sheet": "space.png", "x": 325, "y": 0, "w": 98, "h": 75
  },
  { "name": "powerup-blue", "tags": "powerup blue", "pack": "space", "sheet": "space.png", "x": 696, "y": 329, "w": 34, "h": 33
  },
  { "name": "powerup-blue-bolt", "tags": "powerup blue bolt", "pack": "space", "sheet": "space.png", "x": 539, "y": 989, "w": 34, "h": 33
  },
  { "name": "powerup-blue-shield", "tags": "powerup blue shield", "pack": "space", "sheet": "space.png", "x": 777, "y": 679, "w": 34, "h": 33
  },
  { "name": "powerup-blue-star", "tags": "powerup blue star", "pack": "space", "sheet": "space.png", "x": 776, "y": 895, "w": 34, "h": 33
  },
  { "name": "powerup-green", "tags": "powerup green", "pack": "space", "sheet": "space.png", "x": 774, "y": 613, "w": 34, "h": 33
  },
  { "name": "powerup-green-bolt", "tags": "powerup green bolt", "pack": "space", "sheet": "space.png", "x": 766, "y": 80, "w": 34, "h": 33
  },
  { "name": "powerup-green-shield", "tags": "powerup green shield", "pack": "space", "sheet": "space.png", "x": 776, "y": 862, "w": 34, "h": 33
  },
  { "name": "powerup-green-star", "tags": "powerup green star", "pack": "space", "sheet": "space.png", "x": 651, "y": 490, "w": 34, "h": 33
  },
  { "name": "powerup-red", "tags": "powerup red", "pack": "space", "sheet": "space.png", "x": 491, "y": 182, "w": 34, "h": 33
  },
  { "name": "powerup-red-bolt", "tags": "powerup red bolt", "pack": "space", "sheet": "space.png", "x": 775, "y": 646, "w": 34, "h": 33
  },
  { "name": "powerup-red-shield", "tags": "powerup red shield", "pack": "space", "sheet": "space.png", "x": 776, "y": 928, "w": 34, "h": 33
  },
  { "name": "powerup-red-star", "tags": "powerup red star", "pack": "space", "sheet": "space.png", "x": 774, "y": 977, "w": 34, "h": 33
  },
  { "name": "powerup-yellow", "tags": "powerup yellow", "pack": "space", "sheet": "space.png", "x": 774, "y": 761, "w": 34, "h": 33
  },
  { "name": "powerup-yellow-bolt", "tags": "powerup yellow bolt", "pack": "space", "sheet": "space.png", "x": 740, "y": 761, "w": 34, "h": 33
  },
  { "name": "powerup-yellow-shield", "tags": "powerup yellow shield", "pack": "space", "sheet": "space.png", "x": 482, "y": 325, "w": 34, "h": 33
  },
  { "name": "powerup-yellow-star", "tags": "powerup yellow star", "pack": "space", "sheet": "space.png", "x": 607, "y": 857, "w": 34, "h": 33
  },
  { "name": "scratch-1", "tags": "scratch 1", "pack": "space", "sheet": "space.png", "x": 325, "y": 814, "w": 21, "h": 16
  },
  { "name": "scratch-2", "tags": "scratch 2", "pack": "space", "sheet": "space.png", "x": 423, "y": 41, "w": 21, "h": 16
  },
  { "name": "scratch-3", "tags": "scratch 3", "pack": "space", "sheet": "space.png", "x": 346, "y": 295, "w": 16, "h": 12
  },
  { "name": "shield-1", "tags": "shield 1", "pack": "space", "sheet": "space.png", "x": 0, "y": 412, "w": 133, "h": 108
  },
  { "name": "shield-2", "tags": "shield 2", "pack": "space", "sheet": "space.png", "x": 0, "y": 293, "w": 143, "h": 119
  },
  { "name": "shield-3", "tags": "shield 3", "pack": "space", "sheet": "space.png", "x": 0, "y": 156, "w": 144, "h": 137
  },
  { "name": "shield-bronze", "tags": "shield bronze", "pack": "space", "sheet": "space.png", "x": 797, "y": 143, "w": 30, "h": 30
  },
  { "name": "shield-gold", "tags": "shield gold", "pack": "space", "sheet": "space.png", "x": 797, "y": 113, "w": 30, "h": 30
  },
  { "name": "shield-silver", "tags": "shield silver", "pack": "space", "sheet": "space.png", "x": 778, "y": 824, "w": 30, "h": 30
  },
  { "name": "speed", "tags": "speed", "pack": "space", "sheet": "space.png", "x": 858, "y": 284, "w": 7, "h": 108
  },
  { "name": "star-1", "tags": "star 1", "pack": "space", "sheet": "space.png", "x": 628, "y": 681, "w": 25, "h": 24
  },
  { "name": "star-2", "tags": "star 2", "pack": "space", "sheet": "space.png", "x": 222, "y": 84, "w": 25, "h": 24
  },
  { "name": "star-3", "tags": "star 3", "pack": "space", "sheet": "space.png", "x": 576, "y": 300, "w": 24, "h": 24
  },
  { "name": "star-bronze", "tags": "star bronze", "pack": "space", "sheet": "space.png", "x": 778, "y": 794, "w": 31, "h": 30
  },
  { "name": "star-gold", "tags": "star gold", "pack": "space", "sheet": "space.png", "x": 778, "y": 557, "w": 31, "h": 30
  },
  { "name": "star-silver", "tags": "star silver", "pack": "space", "sheet": "space.png", "x": 778, "y": 527, "w": 31, "h": 30
  },
  { "name": "things-bronze", "tags": "things bronze", "pack": "space", "sheet": "space.png", "x": 778, "y": 495, "w": 32, "h": 32
  },
  { "name": "things-gold", "tags": "things gold", "pack": "space", "sheet": "space.png", "x": 777, "y": 411, "w": 32, "h": 32
  },
  { "name": "things-silver", "tags": "things silver", "pack": "space", "sheet": "space.png", "x": 777, "y": 353, "w": 32, "h": 32
  },
  { "name": "turret-base-big", "tags": "turret base big", "pack": "space", "sheet": "space.png", "x": 310, "y": 982, "w": 41, "h": 41
  },
  { "name": "turret-base-small", "tags": "turret base small", "pack": "space", "sheet": "space.png", "x": 808, "y": 301, "w": 26, "h": 26
  },
  { "name": "ufo-blue", "tags": "ufo blue ship alien", "pack": "space", "sheet": "space.png", "x": 444, "y": 91, "w": 91, "h": 91
  },
  { "name": "ufo-green", "tags": "ufo green ship alien", "pack": "space", "sheet": "space.png", "x": 434, "y": 234, "w": 91, "h": 91
  },
  { "name": "ufo-red", "tags": "ufo red ship alien", "pack": "space", "sheet": "space.png", "x": 444, "y": 0, "w": 91, "h": 91
  },
  { "name": "ufo-yellow", "tags": "ufo yellow ship alien", "pack": "space", "sheet": "space.png", "x": 505, "y": 898, "w": 91, "h": 91
  },
  { "name": "wing-blue-0", "tags": "wing blue 0", "pack": "space", "sheet": "space.png", "x": 647, "y": 924, "w": 45, "h": 78
  },
  { "name": "wing-blue-1", "tags": "wing blue 1", "pack": "space", "sheet": "space.png", "x": 738, "y": 253, "w": 37, "h": 72
  },
  { "name": "wing-blue-2", "tags": "wing blue 2", "pack": "space", "sheet": "space.png", "x": 805, "y": 0, "w": 26, "h": 84
  },
  { "name": "wing-blue-3", "tags": "wing blue 3", "pack": "space", "sheet": "space.png", "x": 600, "y": 450, "w": 51, "h": 75
  },
  { "name": "wing-blue-4", "tags": "wing blue 4", "pack": "space", "sheet": "space.png", "x": 692, "y": 924, "w": 42, "h": 80
  },
  { "name": "wing-blue-5", "tags": "wing blue 5", "pack": "space", "sheet": "space.png", "x": 596, "y": 892, "w": 51, "h": 69
  },
  { "name": "wing-blue-6", "tags": "wing blue 6", "pack": "space", "sheet": "space.png", "x": 694, "y": 847, "w": 42, "h": 74
  },
  { "name": "wing-blue-7", "tags": "wing blue 7", "pack": "space", "sheet": "space.png", "x": 675, "y": 134, "w": 43, "h": 83
  },
  { "name": "wing-green-0", "tags": "wing green 0", "pack": "space", "sheet": "space.png", "x": 650, "y": 525, "w": 45, "h": 78
  },
  { "name": "wing-green-1", "tags": "wing green 1", "pack": "space", "sheet": "space.png", "x": 775, "y": 229, "w": 37, "h": 72
  },
  { "name": "wing-green-2", "tags": "wing green 2", "pack": "space", "sheet": "space.png", "x": 809, "y": 527, "w": 26, "h": 84
  },
  { "name": "wing-green-3", "tags": "wing green 3", "pack": "space", "sheet": "space.png", "x": 535, "y": 0, "w": 51, "h": 75
  },
  { "name": "wing-green-4", "tags": "wing green 4", "pack": "space", "sheet": "space.png", "x": 694, "y": 431, "w": 42, "h": 80
  },
  { "name": "wing-green-5", "tags": "wing green 5", "pack": "space", "sheet": "space.png", "x": 525, "y": 251, "w": 51, "h": 69
  },
  { "name": "wing-green-6", "tags": "wing green 6", "pack": "space", "sheet": "space.png", "x": 695, "y": 511, "w": 42, "h": 74
  },
  { "name": "wing-green-7", "tags": "wing green 7", "pack": "space", "sheet": "space.png", "x": 655, "y": 764, "w": 43, "h": 83
  },
  { "name": "wing-red-0", "tags": "wing red 0", "pack": "space", "sheet": "space.png", "x": 809, "y": 712, "w": 26, "h": 84
  },
  { "name": "wing-red-1", "tags": "wing red 1", "pack": "space", "sheet": "space.png", "x": 768, "y": 0, "w": 37, "h": 72
  },
  { "name": "wing-red-2", "tags": "wing red 2", "pack": "space", "sheet": "space.png", "x": 600, "y": 300, "w": 51, "h": 75
  },
  { "name": "wing-red-3", "tags": "wing red 3", "pack": "space", "sheet": "space.png", "x": 698, "y": 715, "w": 42, "h": 80
  },
  { "name": "wing-red-4", "tags": "wing red 4", "pack": "space", "sheet": "space.png", "x": 586, "y": 75, "w": 51, "h": 69
  },
  { "name": "wing-red-5", "tags": "wing red 5", "pack": "space", "sheet": "space.png", "x": 718, "y": 123, "w": 42, "h": 74
  },
  { "name": "wing-red-6", "tags": "wing red 6", "pack": "space", "sheet": "space.png", "x": 653, "y": 681, "w": 43, "h": 83
  },
  { "name": "wing-red-7", "tags": "wing red 7", "pack": "space", "sheet": "space.png", "x": 651, "y": 286, "w": 45, "h": 78
  },
  { "name": "wing-yellow-0", "tags": "wing yellow 0", "pack": "space", "sheet": "space.png", "x": 650, "y": 603, "w": 45, "h": 78
  },
  { "name": "wing-yellow-1", "tags": "wing yellow 1", "pack": "space", "sheet": "space.png", "x": 760, "y": 120, "w": 37, "h": 72
  },
  { "name": "wing-yellow-2", "tags": "wing yellow 2", "pack": "space", "sheet": "space.png", "x": 809, "y": 353, "w": 26, "h": 84
  },
  { "name": "wing-yellow-3", "tags": "wing yellow 3", "pack": "space", "sheet": "space.png", "x": 576, "y": 150, "w": 51, "h": 75
  },
  { "name": "wing-yellow-4", "tags": "wing yellow 4", "pack": "space", "sheet": "space.png", "x": 726, "y": 0, "w": 42, "h": 80
  },
  { "name": "wing-yellow-5", "tags": "wing yellow 5", "pack": "space", "sheet": "space.png", "x": 525, "y": 182, "w": 51, "h": 69
  },
  { "name": "wing-yellow-6", "tags": "wing yellow 6", "pack": "space", "sheet": "space.png", "x": 695, "y": 585, "w": 42, "h": 74
  },
  { "name": "wing-yellow-7", "tags": "wing yellow 7", "pack": "space", "sheet": "space.png", "x": 651, "y": 364, "w": 43, "h": 83
  },
  { "name": "hitman-1-gun", "tags": "hitman 1 gun pistol", "pack": "topdown", "sheet": "topdown.png", "x": 164, "y": 88, "w": 49, "h": 43
  },
  { "name": "hitman-1-hold", "tags": "hitman 1 hold holding", "pack": "topdown", "sheet": "topdown.png", "x": 386, "y": 88, "w": 35, "h": 43
  },
  { "name": "hitman-1-machine", "tags": "hitman 1 machine rifle", "pack": "topdown", "sheet": "topdown.png", "x": 214, "y": 44, "w": 49, "h": 43
  },
  { "name": "hitman-1-reload", "tags": "hitman 1 reload", "pack": "topdown", "sheet": "topdown.png", "x": 313, "y": 132, "w": 39, "h": 43
  },
  { "name": "hitman-1-silencer", "tags": "hitman 1 silencer pistol", "pack": "topdown", "sheet": "topdown.png", "x": 0, "y": 132, "w": 54, "h": 43
  },
  { "name": "hitman-1-stand", "tags": "hitman 1 stand idle", "pack": "topdown", "sheet": "topdown.png", "x": 426, "y": 176, "w": 33, "h": 43
  },
  { "name": "man-blue-gun", "tags": "man blue gun pistol", "pack": "topdown", "sheet": "topdown.png", "x": 263, "y": 132, "w": 49, "h": 43
  },
  { "name": "man-blue-hold", "tags": "man blue hold holding", "pack": "topdown", "sheet": "topdown.png", "x": 390, "y": 132, "w": 35, "h": 43
  },
  { "name": "man-blue-machine", "tags": "man blue machine rifle", "pack": "topdown", "sheet": "topdown.png", "x": 212, "y": 176, "w": 49, "h": 43
  },
  { "name": "man-blue-reload", "tags": "man blue reload", "pack": "topdown", "sheet": "topdown.png", "x": 309, "y": 0, "w": 39, "h": 43
  },
  { "name": "man-blue-silencer", "tags": "man blue silencer pistol", "pack": "topdown", "sheet": "topdown.png", "x": 58, "y": 0, "w": 54, "h": 43
  },
  { "name": "man-blue-stand", "tags": "man blue stand idle", "pack": "topdown", "sheet": "topdown.png", "x": 426, "y": 132, "w": 33, "h": 43
  },
  { "name": "man-brown-gun", "tags": "man brown gun pistol", "pack": "topdown", "sheet": "topdown.png", "x": 262, "y": 176, "w": 49, "h": 43
  },
  { "name": "man-brown-hold", "tags": "man brown hold holding", "pack": "topdown", "sheet": "topdown.png", "x": 388, "y": 0, "w": 35, "h": 43
  },
  { "name": "man-brown-machine", "tags": "man brown machine rifle", "pack": "topdown", "sheet": "topdown.png", "x": 214, "y": 88, "w": 49, "h": 43
  },
  { "name": "man-brown-reload", "tags": "man brown reload", "pack": "topdown", "sheet": "topdown.png", "x": 312, "y": 176, "w": 39, "h": 43
  },
  { "name": "man-brown-silencer", "tags": "man brown silencer pistol", "pack": "topdown", "sheet": "topdown.png", "x": 0, "y": 176, "w": 54, "h": 43
  },
  { "name": "man-brown-stand", "tags": "man brown stand idle", "pack": "topdown", "sheet": "topdown.png", "x": 459, "y": 44, "w": 33, "h": 43
  },
  { "name": "man-old-gun", "tags": "man old gun pistol", "pack": "topdown", "sheet": "topdown.png", "x": 216, "y": 0, "w": 49, "h": 43
  },
  { "name": "man-old-hold", "tags": "man old hold holding", "pack": "topdown", "sheet": "topdown.png", "x": 422, "y": 88, "w": 35, "h": 43
  },
  { "name": "man-old-machine", "tags": "man old machine rifle", "pack": "topdown", "sheet": "topdown.png", "x": 213, "y": 132, "w": 49, "h": 43
  },
  { "name": "man-old-reload", "tags": "man old reload", "pack": "topdown", "sheet": "topdown.png", "x": 307, "y": 44, "w": 39, "h": 43
  },
  { "name": "man-old-silencer", "tags": "man old silencer pistol", "pack": "topdown", "sheet": "topdown.png", "x": 55, "y": 132, "w": 54, "h": 43
  },
  { "name": "man-old-stand", "tags": "man old stand idle", "pack": "topdown", "sheet": "topdown.png", "x": 460, "y": 132, "w": 33, "h": 43
  },
  { "name": "robot-1-gun", "tags": "robot 1 gun pistol", "pack": "topdown", "sheet": "topdown.png", "x": 164, "y": 44, "w": 49, "h": 43
  },
  { "name": "robot-1-hold", "tags": "robot 1 hold holding", "pack": "topdown", "sheet": "topdown.png", "x": 423, "y": 44, "w": 35, "h": 43
  },
  { "name": "robot-1-machine", "tags": "robot 1 machine rifle", "pack": "topdown", "sheet": "topdown.png", "x": 166, "y": 0, "w": 49, "h": 43
  },
  { "name": "robot-1-reload", "tags": "robot 1 reload", "pack": "topdown", "sheet": "topdown.png", "x": 306, "y": 88, "w": 39, "h": 43
  },
  { "name": "robot-1-silencer", "tags": "robot 1 silencer pistol", "pack": "topdown", "sheet": "topdown.png", "x": 55, "y": 176, "w": 54, "h": 43
  },
  { "name": "robot-1-stand", "tags": "robot 1 stand idle", "pack": "topdown", "sheet": "topdown.png", "x": 458, "y": 88, "w": 33, "h": 43
  },
  { "name": "soldier-1-gun", "tags": "soldier 1 gun pistol", "pack": "topdown", "sheet": "topdown.png", "x": 113, "y": 0, "w": 52, "h": 43
  },
  { "name": "soldier-1-hold", "tags": "soldier 1 hold holding", "pack": "topdown", "sheet": "topdown.png", "x": 349, "y": 0, "w": 38, "h": 43
  },
  { "name": "soldier-1-machine", "tags": "soldier 1 machine rifle", "pack": "topdown", "sheet": "topdown.png", "x": 110, "y": 132, "w": 52, "h": 43
  },
  { "name": "soldier-1-reload", "tags": "soldier 1 reload", "pack": "topdown", "sheet": "topdown.png", "x": 264, "y": 44, "w": 42, "h": 43
  },
  { "name": "soldier-1-silencer", "tags": "soldier 1 silencer pistol", "pack": "topdown", "sheet": "topdown.png", "x": 0, "y": 0, "w": 57, "h": 43
  },
  { "name": "soldier-1-stand", "tags": "soldier 1 stand idle", "pack": "topdown", "sheet": "topdown.png", "x": 353, "y": 132, "w": 36, "h": 43
  },
  { "name": "survivor-1-gun", "tags": "survivor 1 gun pistol", "pack": "topdown", "sheet": "topdown.png", "x": 112, "y": 88, "w": 51, "h": 43
  },
  { "name": "survivor-1-hold", "tags": "survivor 1 hold holding", "pack": "topdown", "sheet": "topdown.png", "x": 352, "y": 176, "w": 37, "h": 43
  },
  { "name": "survivor-1-machine", "tags": "survivor 1 machine rifle", "pack": "topdown", "sheet": "topdown.png", "x": 110, "y": 176, "w": 51, "h": 43
  },
  { "name": "survivor-1-reload", "tags": "survivor 1 reload", "pack": "topdown", "sheet": "topdown.png", "x": 264, "y": 88, "w": 41, "h": 43
  },
  { "name": "survivor-1-silencer", "tags": "survivor 1 silencer pistol", "pack": "topdown", "sheet": "topdown.png", "x": 0, "y": 88, "w": 56, "h": 43
  },
  { "name": "survivor-1-stand", "tags": "survivor 1 stand idle", "pack": "topdown", "sheet": "topdown.png", "x": 390, "y": 176, "w": 35, "h": 43
  },
  { "name": "woman-green-gun", "tags": "woman green gun pistol", "pack": "topdown", "sheet": "topdown.png", "x": 58, "y": 44, "w": 52, "h": 43
  },
  { "name": "woman-green-hold", "tags": "woman green hold holding", "pack": "topdown", "sheet": "topdown.png", "x": 347, "y": 44, "w": 38, "h": 43
  },
  { "name": "woman-green-machine", "tags": "woman green machine rifle", "pack": "topdown", "sheet": "topdown.png", "x": 111, "y": 44, "w": 52, "h": 43
  },
  { "name": "woman-green-reload", "tags": "woman green reload", "pack": "topdown", "sheet": "topdown.png", "x": 266, "y": 0, "w": 42, "h": 43
  },
  { "name": "woman-green-silencer", "tags": "woman green silencer pistol", "pack": "topdown", "sheet": "topdown.png", "x": 0, "y": 44, "w": 57, "h": 43
  },
  { "name": "woman-green-stand", "tags": "woman green stand idle", "pack": "topdown", "sheet": "topdown.png", "x": 386, "y": 44, "w": 36, "h": 43
  },
  { "name": "zombie-1-gun", "tags": "zombie 1 gun pistol", "pack": "topdown", "sheet": "topdown.png", "x": 163, "y": 132, "w": 49, "h": 43
  },
  { "name": "zombie-1-hold", "tags": "zombie 1 hold holding", "pack": "topdown", "sheet": "topdown.png", "x": 424, "y": 0, "w": 35, "h": 43
  },
  { "name": "zombie-1-machine", "tags": "zombie 1 machine rifle", "pack": "topdown", "sheet": "topdown.png", "x": 162, "y": 176, "w": 49, "h": 43
  },
  { "name": "zombie-1-reload", "tags": "zombie 1 reload", "pack": "topdown", "sheet": "topdown.png", "x": 346, "y": 88, "w": 39, "h": 43
  },
  { "name": "zombie-1-silencer", "tags": "zombie 1 silencer pistol", "pack": "topdown", "sheet": "topdown.png", "x": 57, "y": 88, "w": 54, "h": 43
  },
  { "name": "zombie-1-stand", "tags": "zombie 1 stand idle", "pack": "topdown", "sheet": "topdown.png", "x": 460, "y": 0, "w": 33, "h": 43
  }
 ]
};
